import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { usePdfDownloader } from "../common/usePdfDownloader";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";
import AddExistingFiles from "./addExistingFiles";
import Addfreecourse from "./addfreecourse";
import Footer from "./footer";
import FreeCourseRegister from "./freeCourseRegister";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";
import ProfileBanner from "./profileBanner";

// Constants
// const CATEGORIES_ARRAY = [
// 	"On-Farm Production",
// 	"Food Safety and Standards Authority of India",
// 	"Post Harvest Processing",
// 	"Sustainability Standards",
// 	"USDA NOP",
// 	"Packhouse Recognition for Exports",
// 	"Skill Development for Quality Personnel: Mastering Auditing Principles (ISO 19011:2018)",
// 	"Skill Development in Food Safety and Food Hygiene",
// 	"Farmers Organizations: Skill Developement",
// 	"Empowering Agripreneurs",
// 	"Students: Skill Development for Students in Agriculture, Horticulture, and Food Sciences",
// 	"Natural Farming Certification System (NFCS)",
// 	"Agro-Biodiversity",
// 	"Chain of Custody"
// ];

const INITIAL_TEXT_LIST = [{ name: "", file: "", section: "" }];
const INITIAL_REFERENCE_LIST = [
	{
		title: "",
		name: "",
		file: "",
		fileName: "",
		link: "",
		source: "",
		description: "",
	},
];

const Courses = () => {
	const { profile, auth } = useSelector((state) => state);
	const dispatch = useDispatch();
	const downloadPdf = usePdfDownloader();

	// Core data states
	const [freeCourses, setFreeCourses] = useState([]);
	const [organisationArray, setOrganisationArray] = useState([]);
	const [userRole, setUserRole] = useState("");
	const [communitiesArray, setCommunitiesArray] = useState([]);
	const [communities, setCommunities] = useState([]);
	const [userCourses, setUserCourses] = useState([]);
	const [languages, setLanguages] = useState([]);
	const [references, setReferences] = useState([]);
	const [savedCourses, setSavedCourses] = useState([]);

	// Modal states - grouped for better organization
	const [showUploadModal, setShowUploadModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showCategorieModal, setShowCategorieModal] = useState(false);
	const [showSubCategorieModal, setShowSubCategorieModal] = useState(false);
	const [showLanguageModal, setShowLanguageModal] = useState(false);
	const [showReferenceModal, setShowReferenceModal] = useState(false);

	// Form states - grouped for better organization
	const [retake, setRetake] = useState(false);
	const [courseCategorieArray, setCourseCategorieArray] = useState([]);
	const [courseSubCategorieArray, setCourseSubCategorieArray] = useState([]);
	const [courseImage, setCourseImage] = useState("");
	const [courseTitle, setCourseTitle] = useState("");
	const [aboutCourse, setAboutCourse] = useState("");
	const [topics, setTopics] = useState("");
	const [courseDuration, setCourseDuration] = useState("");
	const [courseValidity, setCourseValidity] = useState("");
	const [questionsDuration, setQuestionsDuration] = useState("");
	const [targetAudience, setTargetAudience] = useState("");
	const [cost, setCost] = useState("");
	const [stepsInvolved, setStepsInvolved] = useState("");
	const [modules, setModules] = useState("");
	const [learningOutcomes, setLearningOutcomes] = useState("");
	const [obtaining, setObtaining] = useState("");
	const [eligibility, setEligibility] = useState("");
	const [proceed, setProceed] = useState("");

	// File states - grouped for better organization
	const [courseOverviewFile, setCourseOverviewFile] = useState("");
	const [topicsFile, setTopicsFile] = useState("");
	const [outcomesFile, setOutcomesFile] = useState("");
	const [obtainingFile, setObtainingFile] = useState("");
	const [eligibilityFile, setEligibilityFile] = useState("");
	const [proceedFile, setProceedFile] = useState("");
	const [courseOverviewActualFile, setCourseOverviewActualFile] = useState("");
	const [topicsActualFile, setTopicsActualFile] = useState("");
	const [outcomesActualFile, setOutcomesActualFile] = useState("");
	const [obtainingActualFile, setObtainingActualFile] = useState("");
	const [eligibilityActualFile, setEligibilityActualFile] = useState("");
	const [proceedActualFile, setProceedActualFile] = useState("");
	const [stepsInvolvedFile, setStepsInvolvedFile] = useState("");
	const [stepsInvolvedActualFile, setStepsInvolvedActualFile] = useState("");

	// Selection states - grouped for better organization
	const [courseName, setCourseName] = useState("");
	const [subCourseName, setSubCourseName] = useState("");
	const [language, setLanguage] = useState("");
	const [reference, setReference] = useState("");
	const [courseDescription, setCourseDescription] = useState("");
	const [subCourseDescription, setSubCourseDescription] = useState("");
	const [selectedCategory, setSelectedCategory] = useState("");
	const [selectedSubCategory, setSelectedSubCategory] = useState("");
	const [selectedLanguage, setSelectedLanguage] = useState("");
	const [textlist, setTextlist] = useState(INITIAL_TEXT_LIST);

	// Drag and Drop states
	const [draggedItem, setDraggedItem] = useState(null);
	const [draggedReferenceItem, setDraggedReferenceItem] = useState(null);
	const [draggedQuestionItem, setDraggedQuestionItem] = useState(null);
	const [referencelist, setReferencelist] = useState(INITIAL_REFERENCE_LIST);
	const [question, setQuestion] = useState("");
	const [answers, setAnswers] = useState("");
	const [questionAnswer, setQuestionAnswer] = useState("");
	const [questionsList, setQuestionsList] = useState([]);
	const [filesList, setfilesList] = useState([]);
	const [referencefilesList, setReferencefilesList] = useState([]);
	const [addbutton, setAddbutton] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [selectedCourse, setSelectedCourse] = useState({});
	const [activeKey, setActiveKey] = useState(false);

	// Language filtering and search state
	const [selectedDisplayLanguage, setSelectedDisplayLanguage] = useState("");
	const [courseSearchValue, setCourseSearchValue] = useState("");

	// My Courses search and filtering state
	const [myCoursesSearchValue, setMyCoursesSearchValue] = useState("");
	const [selectedMyCoursesLanguage, setSelectedMyCoursesLanguage] =
		useState("");

	// Active tab state
	const [activeTab, setActiveTab] = useState("courses");

	// Add this
	const [refreshTrigger, setRefreshTrigger] = useState(0);

	// Loading states
	const [auxLoading, setAuxLoading] = useState(true);
	const [auxError, setAuxError] = useState(null);
	useEffect(() => {
		setAuxLoading(true);
		setAuxError(null);
		Promise.all([
			getDataAPI("getcoursecategory", auth.token),
			getDataAPI("getlanguages", auth.token),
			getDataAPI("getreferences", auth.token),
			getDataAPI("getfreecourses"),
		])
			.then(([catRes, langRes, refRes, freeRes]) => {
				setCourseCategorieArray(catRes.data.categories || []);
				setLanguages(langRes.data.languages || []);
				setReferences(refRes.data.references || []);
				setFreeCourses(freeRes.data.freecourses || []);
				setOrganisationArray(freeRes.data.organisationNames || []);
				setAuxLoading(false);
			})
			.catch((err) => {
				setAuxError(err);
				setAuxLoading(false);
			});
	}, [auth.token, refreshTrigger]);

	useEffect(() => {
		if (selectedCategory !== "") {
			trackPromise(
				getDataAPI(`getcoursesubcategory/${selectedCategory}`, auth.token).then(
					(res) => {
						setCourseSubCategorieArray(res.data.subcategories);
					},
				),
			);
		}
	}, [selectedCategory]);

	useEffect(() => {
		console.log("savedCourses", savedCourses);
	}, [savedCourses]);

	// Main data loading states
	const [mainLoading, setMainLoading] = useState(true);
	const [mainError, setMainError] = useState(null);

	// Question options state
	const [selectedOptions, setSelectedOptions] = useState({});

	// Email validation regex
	const validEmailExp = new RegExp(
		"^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
	);

	const [cdst, setcdst] = useState([]);
	useEffect(() => {
		setMainLoading(true);
		setMainError(null);
		if (auth.token) {
			setUserRole(auth.user.role);
			// console.log("auth", auth);

			Promise.all([
				// getDataAPI(
				// 	`getcommunityuser/${auth.user.id}/${
				// 		window.location.pathname.split("/")[2]
				// 	}`,
				// 	auth.token
				// ),
				getDataAPI(
					`getAllCourses/${auth.user.id}/${
						window.location.pathname.split("/")[2]
					}`,
					auth.token,
				),
				getDataAPI(`getusersavedbyid/${auth.user.id}`, auth.token),
				getDataAPI(`getSavedCourses/${auth.user.id}`, auth.token),
				getDataAPI(`getCourseDetailsByUserid/${auth.user.id}`, auth.token), // changed
			])
				.then(
					([coursesRes, userSavedRes, savedCoursesRes, courseDetailsRes]) => {
						setCommunitiesArray(coursesRes.data.courses || []);
						setCommunities(coursesRes.data.courses || []);
						setcdst(courseDetailsRes.data.coursedetails);
						console.log(courseDetailsRes.data.coursedetails);
						if (
							userSavedRes.data.usersaved &&
							userSavedRes.data.usersaved.courses !== ""
						) {
							setUserCourses(JSON.parse(userSavedRes.data.usersaved.courses));
						}
						setSavedCourses(savedCoursesRes.data.courses || []);
						setMainLoading(false);
					},
				)
				.catch((err) => {
					setMainError(err);
					setMainLoading(false);
				});
		} else {
			getDataAPI(
				`getAllCoursesWithoutLogin/9ae8b71c-dd3f-4fad-b1ee-e872f951e7af`,
			)
				.then((res) => {
					setCommunitiesArray(res.data.courses || []);
					setCommunities(res.data.courses || []);
					setMainLoading(false);
				})
				.catch((err) => {
					setMainError(err);
					setMainLoading(false);
				});
		}
		if (localStorage.getItem("isStudents")) {
			setTimeout(() => {
				localStorage.removeItem("isStudents");
			}, 1000);
			setActiveKey("Students");
		}
	}, [auth]);

	useEffect(() => {
		if (searchValue === "") {
			setCommunitiesArray(communities);
			return;
		}
		const filterBySearch = communities.filter((item) => {
			const searchTerm = searchValue.toLowerCase();
			return (
				JSON.stringify(item.coursetitle).toLowerCase().includes(searchTerm) ||
				JSON.stringify(item.cost).toLowerCase().includes(searchTerm) ||
				JSON.stringify(item.targetaudience)
					.toLowerCase()
					.includes(searchTerm) ||
				JSON.stringify(item.category).toLowerCase().includes(searchTerm)
			);
		});

		setCommunitiesArray(filterBySearch);
	}, [searchValue, communities]);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const tabParam = params.get("tab");
		if (tabParam === "mycourses") {
			setActiveTab("mycourses");
		}
	}, []);

	// Memoized filtered arrays for search and language filtering
	const filteredCoursesArray = useMemo(() => {
		if (courseSearchValue === "") return communitiesArray;
		return communitiesArray.filter((item) => {
			const searchTerm = courseSearchValue.toLowerCase();
			return (
				(item?.coursetitle || "").toLowerCase().includes(searchTerm) ||
				(item?.cost || "").toLowerCase().includes(searchTerm) ||
				(item?.language?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.category?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.subcategory?.name || "").toLowerCase().includes(searchTerm)
			);
		});
	}, [courseSearchValue, communitiesArray]);

	// Memoized language filter
	const displayCoursesArray = useMemo(() => {
		if (selectedDisplayLanguage === "") return filteredCoursesArray;
		return filteredCoursesArray.filter(
			(item) => item.language?.id === selectedDisplayLanguage,
		);
	}, [selectedDisplayLanguage, filteredCoursesArray]);

	// Memoized filtered arrays for My Courses search and language filtering
	const filteredMyCoursesArray = useMemo(() => {
		if (myCoursesSearchValue === "") return communitiesArray;
		return communitiesArray.filter((item) => {
			const searchTerm = myCoursesSearchValue.toLowerCase();
			return (
				(item?.coursetitle || "").toLowerCase().includes(searchTerm) ||
				(item?.cost || "").toLowerCase().includes(searchTerm) ||
				(item?.language?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.category?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.subcategory?.name || "").toLowerCase().includes(searchTerm)
			);
		});
	}, [myCoursesSearchValue, communitiesArray]);

	// Memoized language filter for My Courses
	const displayMyCoursesArray = useMemo(() => {
		if (selectedMyCoursesLanguage === "") return filteredMyCoursesArray;
		return filteredMyCoursesArray.filter(
			(item) => item.language?.id === selectedMyCoursesLanguage,
		);
	}, [selectedMyCoursesLanguage, filteredMyCoursesArray]);

	// Memoized filtered arrays for Free Courses search and language filtering
	const filteredFreeCoursesArray = useMemo(() => {
		if (courseSearchValue === "") return freeCourses;
		return freeCourses.filter((item) => {
			const searchTerm = courseSearchValue.toLowerCase();
			return (
				(item?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.subject || "").toLowerCase().includes(searchTerm) ||
				(item?.language?.name || "").toLowerCase().includes(searchTerm) ||
				(item?.organisation?.name || "").toLowerCase().includes(searchTerm)
			);
		});
	}, [courseSearchValue, freeCourses]);

	// Memoized language filter for Free Courses
	const displayFreeCoursesArray = useMemo(() => {
		if (selectedDisplayLanguage === "") return filteredFreeCoursesArray;
		return filteredFreeCoursesArray.filter(
			(item) => item.language?.id === selectedDisplayLanguage,
		);
	}, [selectedDisplayLanguage, filteredFreeCoursesArray]);

	// Helper functions to check if categories/subcategories have courses - memoized with useCallback
	const hasCoursesInCategory = useCallback(
		(categoryId) => {
			return displayCoursesArray.some(
				(course) => course.category?.id === categoryId,
			);
		},
		[displayCoursesArray],
	);

	const hasCoursesInSubcategory = useCallback(
		(subcategoryId) => {
			return displayCoursesArray.some(
				(course) => course.subcategory?.id === subcategoryId,
			);
		},
		[displayCoursesArray],
	);

	// Helper functions to check if free course organizations have courses
	const hasFreeCoursesInOrganization = useCallback(
		(organizationName) => {
			return displayFreeCoursesArray.some(
				(course) => course.organisation?.name === organizationName,
			);
		},
		[displayFreeCoursesArray],
	);

	const hasAnyCourses = useCallback(() => {
		return displayCoursesArray.length > 0 || displayFreeCoursesArray.length > 0;
	}, [displayCoursesArray.length, displayFreeCoursesArray.length]);

	const hasAnyFreeCourses = useCallback(() => {
		return displayFreeCoursesArray.length > 0;
	}, [displayFreeCoursesArray.length]);

	const handleEditCourse = useCallback((course) => {
		setSelectedCourse(course);
		setShowEditModal(true);
		setSelectedCategory(course.category.id);
		setSelectedSubCategory(course.subcategory.id);
		setSelectedLanguage(course.language.id);
		setCourseImage(course.courseimage);
		setCourseTitle(course.coursetitle);
		setAboutCourse(course.aboutcourse);
		setCourseOverviewFile(course.overviewfile);
		setTopics(course.topics);
		setTopicsFile(course.topicsfile);
		setTargetAudience(course.targetaudience);
		setModules(course.modules);
		setCourseDuration(course.duration);
		setCourseValidity(course.validity);
		setQuestionsDuration(course.questionsduration);
		setLearningOutcomes(course.learningoutcome);
		setOutcomesFile(course.outcomesfile);
		setObtaining(course.obtaining);
		setObtainingFile(course.obtainingfile);
		setEligibility(course.eligibility);
		setEligibilityFile(course.eligibilityfile);
		setProceed(course.howtoproceed);
		setProceedFile(course.howtoproceedfile);
		course.textlist.length > 0
			? setTextlist(course.textlist)
			: setTextlist(INITIAL_TEXT_LIST);
		course.referencelist.length > 0
			? setReferencelist(course.referencelist)
			: setReferencelist(INITIAL_REFERENCE_LIST);
		setRetake(course.retake);
		setCost(course.cost);
		setQuestionsList(course.questionlist);
	}, []);

	const handlePushItemIntoCourseCategorieArray = async () => {
		try {
			const res = await postDataAPI(
				"createcoursecategory",
				{
					name: courseName,
					description: courseDescription,
				},
				auth.token,
			);
			if (res.status === 200) {
				setCourseCategorieArray((prev) => [...prev, res.data.category]);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setShowCategorieModal(false);
	};

	const handlePushItemsIntoArray = async () => {
		dispatch({
			type: GLOBALTYPES.ALERT,
			payload: { loading: true },
		});
		setShowUploadModal(false);

		const formData = new FormData();
		filesList.forEach((file) => formData.append("files", file));
		referencefilesList.forEach((file) => formData.append("files", file));

		if (stepsInvolvedActualFile !== "") {
			formData.append(
				"files",
				stepsInvolvedActualFile,
				"stepsinvolvedfile.pdf",
			);
		}
		if (courseOverviewActualFile !== "") {
			formData.append("files", courseOverviewActualFile, "courseoverview.pdf");
		}
		if (topicsActualFile !== "") {
			formData.append("files", topicsActualFile, "coursetopics.pdf");
		}
		if (outcomesActualFile !== "") {
			formData.append("files", outcomesActualFile, "courseoutcomes.pdf");
		}
		if (obtainingActualFile !== "") {
			formData.append("files", obtainingActualFile, "courseobtaining.pdf");
		}
		if (eligibilityActualFile !== "") {
			formData.append("files", eligibilityActualFile, "courseeligibility.pdf");
		}
		if (proceedActualFile !== "") {
			formData.append("files", proceedActualFile, "coursehowtoproceed.pdf");
		}

		const courseData = {
			admin: auth.user.id,
			courseimage: courseImage,
			coursetitle: courseTitle,
			aboutcourse: aboutCourse,
			duration: courseDuration,
			validity: courseValidity,
			questionsduration: questionsDuration,
			targetaudience: targetAudience,
			modules: modules,
			learningoutcome: learningOutcomes,
			stepsinvolved: stepsInvolved,
			stepsinvolvedfile: stepsInvolvedActualFile,
			files: formData,
			fileslist: filesList,
			textlist: textlist,
			referencelist: referencelist,
			questionlist: questionsList,
			retake: retake,
			cost: cost,
			category: selectedCategory,
			subcategory: selectedSubCategory,
			language: selectedLanguage,
			communityid: window.location.pathname.split("/")[2],
			topics,
			obtaining,
			eligibility,
			proceed,
		};

		Object.keys(courseData).forEach((key) => {
			formData.append(
				key,
				typeof courseData[key] === "object"
					? JSON.stringify(courseData[key])
					: courseData[key],
			);
		});

		try {
			const res = await postDataAPI("createcourse", formData, auth.token);
			if (res.status === 200) {
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setQuestionsList([]);
		setTextlist(INITIAL_TEXT_LIST);
		setReferencelist(INITIAL_REFERENCE_LIST);
		setCost("");
		setShowUploadModal(false);
	};

	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [courseToDelete, setCourseToDelete] = useState(null);

	const handleConfirmDelete = async () => {
		if (!courseToDelete) return;

		try {
			const res = await getDataAPI(
				`inactivecourse/${courseToDelete.id}/${
					window.location.pathname.split("/")[2]
				}`,
				auth.token,
			);
			if (res.status === 200) {
				window.location.reload();
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		} finally {
			setShowDeleteModal(false);
			setCourseToDelete(null);
		}
	};

	const handleDeleteClick = (course) => {
		setCourseToDelete(course);
		setShowDeleteModal(true);
	};

	const handleCloseDeleteModal = () => {
		setShowDeleteModal(false);
		setCourseToDelete(null);
	};

	const handleSetCourseInactive = async (course) => {
		try {
			const res = await getDataAPI(
				`inactivecourse/${course.id}/${window.location.pathname.split("/")[2]}`,
				auth.token,
			);
			if (res.status === 200) {
				window.location.reload();
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}
	};

	useEffect(() => {
		if (localStorage.getItem("isStudents")) {
			window.scrollBy({
				top: 2500, // pixels to scroll vertically
				behavior: "smooth", // smooth scroll
			});
		}
	}, [courseCategorieArray]);

	const handleUploadlanguage = async () => {
		try {
			const res = await postDataAPI(
				"createlanguage",
				{
					name: language,
				},
				auth.token,
			);
			if (res.status === 200) {
				setLanguages((prev) => [...prev, res.data.language]);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setShowLanguageModal(false);
	};

	const handleUploadReference = async () => {
		try {
			const res = await postDataAPI(
				"createreference",
				{
					name: reference,
				},
				auth.token,
			);
			if (res.status === 200) {
				setReferences((prev) => [...prev, res.data.reference]);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setShowReferenceModal(false);
		setShowUploadModal(true);
	};

	const handleEditSubmit = async () => {
		dispatch({
			type: GLOBALTYPES.ALERT,
			payload: { loading: true },
		});
		setShowEditModal(false);

		const formData = new FormData();
		filesList.forEach((file) => formData.append("files", file));
		referencefilesList.forEach((file) => formData.append("files", file));

		const fileFields = [
			{ file: stepsInvolvedActualFile, name: "stepsinvolvedfile.pdf" },
			{ file: courseOverviewActualFile, name: "courseoverview.pdf" },
			{ file: topicsActualFile, name: "coursetopics.pdf" },
			{ file: outcomesActualFile, name: "courseoutcomes.pdf" },
			{ file: obtainingActualFile, name: "courseobtaining.pdf" },
			{ file: eligibilityActualFile, name: "courseeligibility.pdf" },
			{ file: proceedActualFile, name: "coursehowtoproceed.pdf" },
		];

		fileFields.forEach(({ file, name }) => {
			if (file !== "" && typeof file === "object") {
				formData.append("files", file, name);
			}
		});

		const courseData = {
			courseid: selectedCourse.id,
			admin: auth.user.id,
			courseimage: courseImage,
			coursetitle: courseTitle,
			aboutcourse: aboutCourse,
			duration: courseDuration,
			validity: courseValidity,
			questionsduration: questionsDuration,
			targetaudience: targetAudience,
			modules: modules,
			learningoutcome: learningOutcomes,
			stepsinvolved: stepsInvolved,
			stepsinvolvedfile: stepsInvolvedActualFile,
			files: formData,
			fileslist: filesList,
			textlist: textlist,
			referencelist: referencelist,
			questionlist: questionsList,
			retake: retake,
			cost: cost,
			category: selectedCategory,
			subcategory: selectedSubCategory,
			language: selectedLanguage,
			communityid: window.location.pathname.split("/")[2],
			topics,
			obtaining,
			eligibility,
			proceed,
			reffilecount: referencefilesList.length,
			textfilecount: filesList.length,
		};

		Object.keys(courseData).forEach((key) => {
			formData.append(
				key,
				typeof courseData[key] === "object"
					? JSON.stringify(courseData[key])
					: courseData[key],
			);
		});

		try {
			const res = await postDataAPI("updatecourse", formData, auth.token);
			if (res.status === 200) {
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setQuestionsList([]);
		setTextlist(INITIAL_TEXT_LIST);
		setReferencelist(INITIAL_REFERENCE_LIST);
		setCost("");
		setShowUploadModal(false);
	};

	const buttonClick = (e) => {
		setShowUploadModal(true);
	};
	const handleCloseUploadModal = useCallback(() => {
		setShowUploadModal(false);
	}, []);

	const handleCloseEditModal = useCallback(() => {
		setQuestionsList([]);
		setTextlist(INITIAL_TEXT_LIST);
		setReferencelist(INITIAL_REFERENCE_LIST);
		setCost("");
		setShowEditModal(false);
	}, []);

	const handleCloseCategorieModal = useCallback(() => {
		setShowCategorieModal(false);
		// setShowUploadModal(true);
	}, []);

	const handleCloseSubCategorieModal = useCallback(() => {
		setShowSubCategorieModal(false);
		// setShowUploadModal(true);
	}, []);

	const handleCloseLanguageModal = useCallback(() => {
		setShowLanguageModal(false);
		// setShowUploadModal(true);
	}, []);

	const handleCloseReferenceModal = useCallback(() => {
		setShowReferenceModal(false);
		// setShowUploadModal(true);
	}, []);

	//changed
	const [startedCourses, setStartedCourses] = useState({});

	// const handleClick = async (
	//   file,
	//   image,
	//   title,
	//   question,
	//   id,
	//   admin,
	//   details
	// ) => {
	//   if (details === 0) {
	//     try {
	//       const res = await postDataAPI(
	//         "createCourseDetails",
	//         {
	//           userid: auth.user.id,
	//           courseid: id,
	//           adminid: admin,
	//         },
	//         auth.token
	//       );
	//       if (res.status === 200) {
	//         // Course details created successfully
	//       }
	//     } catch (err) {
	//       dispatch({
	//         type: GLOBALTYPES.ALERT,
	//         payload: { error: err.response.data.msg },
	//       });
	//     }
	//   }

	//   window.open("/pdfreader/" + id, "_blank");
	// };

	const handleClick = async (
		file,
		image,
		title,
		question,
		id,
		admin,
		details,
	) => {
		// only create course details if not already started
		if (!startedCourses[id] && details === 0) {
			try {
				const res = await postDataAPI(
					"createCourseDetails",
					{
						userid: auth.user.id,
						courseid: id,
						adminid: admin,
					},
					auth.token,
				);

				if (res.status === 200) {
					// mark this course as started locally
					setStartedCourses((prev) => ({ ...prev, [id]: true }));
				}
			} catch (err) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: err.response.data.msg },
				});
			}
		}

		window.open("/pdfreader/" + id, "_blank");
	};

	const handlePushItemIntoCourseSubCategorieArray = async () => {
		try {
			const res = await postDataAPI(
				"createcoursesubcategory",
				{
					name: subCourseName,
					description: subCourseDescription,
					categoryid: selectedCategory,
				},
				auth.token,
			);
			if (res.status === 200) {
				setCourseSubCategorieArray((prev) => [...prev, res.data.subcategory]);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}

		setShowSubCategorieModal(false);
	};

	const handleCourseImage = useCallback((event) => {
		if (event.target.files && event.target.files[0]) {
			let reader = new FileReader();
			reader.onload = (e) => {
				setCourseImage(e.target.result);
			};
			reader.readAsDataURL(event.target.files[0]);
		}
	}, []);

	const handleCourseOverviewFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setCourseOverviewFile(url);
			setCourseOverviewActualFile(file);
		}
	}, []);

	const handleTopicsFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setTopicsFile(url);
			setTopicsActualFile(file);
		}
	}, []);

	const handleOutcomesFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setOutcomesFile(url);
			setOutcomesActualFile(file);
		}
	}, []);

	const handleObtainingFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setObtainingFile(url);
			setObtainingActualFile(file);
		}
	}, []);

	const handleEligibilityFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setEligibilityFile(url);
			setEligibilityActualFile(file);
		}
	}, []);

	const handleProceedFile = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setProceedFile(url);
			setProceedActualFile(file);
		}
	}, []);

	const handlertextrchange = useCallback((e, index) => {
		const { name, value } = e.target;
		setTextlist((prev) => {
			const list = [...prev];
			list[index][name] = value;
			return list;
		});
	}, []);

	const handlereferencechange = useCallback(
		(e, index) => {
			const { name, value } = e.target;
			setReferencelist((prev) => {
				const list = [...prev];
				if (name === "title") {
					const selectedReference = references.find((ref) => ref.id === value);
					list[index][name] = selectedReference || value;
				} else {
					list[index][name] = value;
				}
				return list;
			});
		},
		[references],
	);

	const handleFile = useCallback((e, index) => {
		const file = e.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setTextlist((prev) => {
				const list = [...prev];
				list[index].file = url;
				list[index].fileName = file.name; // Store the filename
				return list;
			});
			setfilesList((prev) => {
				const list = [...prev];
				list[index] = file;
				return list;
			});
		}
	}, []);

	const handleFileDrop = useCallback((e, index) => {
		e.preventDefault();
		const files = e.dataTransfer.files;
		if (files && files.length > 0) {
			const file = files[0];
			if (file.type === "application/pdf") {
				const url = URL.createObjectURL(file);
				setTextlist((prev) => {
					const list = [...prev];
					list[index].file = url;
					list[index].fileName = file.name; // Store the filename
					return list;
				});
				setfilesList((prev) => {
					const list = [...prev];
					list[index] = file;
					return list;
				});
			}
		}
	}, []);

	const handleFileDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "copy";
	}, []);

	const handleReferenceFile = useCallback((e, index) => {
		const file = e.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setReferencelist((prev) => {
				const list = [...prev];
				list[index].file = url;
				list[index].fileName = file.name;
				return list;
			});
			setReferencefilesList((prev) => {
				const list = [...prev];
				list[index] = file;
				return list;
			});
		}
	}, []);

	const handleReferenceFileDrop = useCallback((e, index) => {
		e.preventDefault();
		const files = e.dataTransfer.files;
		if (files && files.length > 0) {
			const file = files[0];
			if (file.type === "application/pdf") {
				const url = URL.createObjectURL(file);
				setReferencelist((prev) => {
					const list = [...prev];
					list[index].file = url;
					list[index].fileName = file.name;
					return list;
				});
				setReferencefilesList((prev) => {
					const list = [...prev];
					list[index] = file;
					return list;
				});
			}
		}
	}, []);

	const handleReferenceFileDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "copy";
	}, []);

	const handlertextremove = useCallback((index) => {
		setTextlist((prev) => {
			const list = [...prev];
			list.splice(index, 1);
			return list;
		});
	}, []);

	const handlerquestionremove = useCallback((index) => {
		setQuestionsList((prev) => {
			const list = [...prev];
			list.splice(index, 1);
			return list;
		});
	}, []);

	const handlereferenceremove = useCallback((index) => {
		setReferencelist((prev) => {
			const list = [...prev];
			list.splice(index, 1);
			return list;
		});
	}, []);

	const handleTextadd = useCallback(() => {
		setTextlist((prev) => [...prev, { name: "", file: "", section: "" }]);
	}, []);

	const handleReferenceadd = useCallback(() => {
		setReferencelist((prev) => [
			...prev,
			{
				title: "",
				name: "",
				file: "",
				fileName: "",
				link: "",
				source: "",
				description: "",
			},
		]);
	}, []);

	// Helper function to get reference name
	const getReferenceName = useCallback(
		(title) => {
			if (typeof title === "object" && title?.name) {
				return title.name;
			}
			if (typeof title === "string" && title) {
				const ref = references.find((r) => r.id === title);
				return ref?.name || title;
			}
			return "";
		},
		[references],
	);

	// Drag and Drop handlers for textlist - optimized with useCallback
	const handleDragStart = useCallback((e, index) => {
		setDraggedItem(index);
		e.dataTransfer.effectAllowed = "move";
	}, []);

	const handleDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}, []);

	const handleDrop = useCallback(
		(e, index) => {
			e.preventDefault();
			if (draggedItem === null || draggedItem === index) return;

			setTextlist((prev) => {
				const list = [...prev];
				const draggedItemData = list[draggedItem];
				list.splice(draggedItem, 1);
				list.splice(index, 0, draggedItemData);
				return list;
			});
			setDraggedItem(null);
		},
		[draggedItem],
	);

	const handleDragEnd = useCallback(() => {
		setDraggedItem(null);
	}, []);

	// Drag and Drop handlers for referencelist
	const handleReferenceDragStart = useCallback((e, index) => {
		setDraggedReferenceItem(index);
		e.dataTransfer.effectAllowed = "move";
	}, []);

	const handleReferenceDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}, []);

	const handleReferenceDrop = useCallback(
		(e, index) => {
			e.preventDefault();
			if (draggedReferenceItem === null || draggedReferenceItem === index)
				return;

			setReferencelist((prev) => {
				const list = [...prev];
				const draggedItemData = { ...list[draggedReferenceItem] };
				list.splice(draggedReferenceItem, 1);
				list.splice(index, 0, draggedItemData);
				return list;
			});
			setDraggedReferenceItem(null);
		},
		[draggedReferenceItem],
	);

	const handleReferenceDragEnd = useCallback(() => {
		setDraggedReferenceItem(null);
	}, []);

	const handleQuestionDragStart = useCallback((e, index) => {
		setDraggedQuestionItem(index);
		e.dataTransfer.effectAllowed = "move";
	}, []);

	const handleQuestionDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}, []);

	const handleQuestionDrop = useCallback(
		(e, index) => {
			e.preventDefault();
			if (draggedQuestionItem !== null && draggedQuestionItem !== index) {
				setQuestionsList((prev) => {
					const newQuestionsList = [...prev];
					const draggedItemData = newQuestionsList[draggedQuestionItem];
					newQuestionsList.splice(draggedQuestionItem, 1);
					newQuestionsList.splice(index, 0, draggedItemData);
					return newQuestionsList;
				});
			}
			setDraggedQuestionItem(null);
		},
		[draggedQuestionItem],
	);

	const handleQuestionDragEnd = useCallback(() => {
		setDraggedQuestionItem(null);
	}, []);

	const getButtonClass = useCallback(() => {
		let str = [];
		let rvalue = "aebuttongrey";
		textlist.forEach((list) => {
			if (
				list.email !== "" &&
				list.name !== "" &&
				validEmailExp.test(list.email)
			) {
				str.push("full");
			} else {
				str.push("notfull");
			}
		});

		let mstr = "," + str.join() + ",";
		if (mstr.indexOf(",notfull,") >= 0) {
			rvalue = "aebuttongrey";
		} else {
			rvalue = "aebuttonblack";
		}
		return rvalue;
	}, [textlist]);

	const handleShowQuestion = () => {
		const test = answers
			.split(",")
			.map((part) => part.trim())
			.join(",")
			.split(",");

		if (test.includes(questionAnswer)) {
			const item = {
				question: question,
				options: test,
				answer: questionAnswer,
			};
			setQuestionsList((prevState) => [...prevState, item]);
			setQuestion("");
			setAnswers("");
			setQuestionAnswer("");
		} else {
			alert("Please Give correct option");
		}
	};

	const handleOptionChange = (questionIndex, selectedOption) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			[questionIndex]: selectedOption,
		}));
	};

	//changed
	const displayMyCoursesWithStartTime = useMemo(() => {
		if (!displayMyCoursesArray || displayMyCoursesArray.length === 0) return [];

		return displayMyCoursesArray.map((course) => {
			// Find matching course details by course id
			const details = cdst.find((c) => c.courseid === course.id);
			return {
				...course,
				coursestarttime: details ? details.coursestarttime : "", // add starttime or null
			};
		});
	}, [displayMyCoursesArray, cdst]);

	useEffect(() => {
		console.log("displayMyCoursesWithStartTime", displayMyCoursesWithStartTime);
	}, [displayMyCoursesWithStartTime]);
	//changed

	return (
		<>
			<Modal
				show={showUploadModal}
				onHide={handleCloseUploadModal}
				dialogClassName="modal-sm-30px"
				size="xl"
				backdropClassName="childmodal"
				// backdrop="static"
				centered
				// onEntered={() => props.handleEntered}
			>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Upload Course
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer", textAlign: "right" }}
							onClick={handleCloseUploadModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div className="row">
						<div className="col-7">
							<div>
								<div style={{ paddingTop: "10px", fontSize: "13px" }}>
									Welcome and Introduction
								</div>
								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Categorie:</div>
									<select
										name="category"
										style={{ width: "85%" }}
										onChange={(e) => setSelectedCategory(e.target.value)}>
										<option value="">Select</option>
										{courseCategorieArray.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									<span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												window.location.href = "/coursecategorymanangement";
												// setShowCategorieModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span>
								</div>

								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Sub Categorie:</div>
									<select
										name="subcategory"
										onChange={(e) => setSelectedSubCategory(e.target.value)}>
										<option value="">Select</option>
										{courseSubCategorieArray.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									{/* <span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												setShowSubCategorieModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span> */}
								</div>

								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Language:</div>
									<select
										name="language"
										onChange={(e) => setSelectedLanguage(e.target.value)}>
										<option value="">Select</option>
										{languages.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									<span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												setShowLanguageModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span>
								</div>
								<div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Image:</div>
									<input
										type="file"
										className="form-control"
										accept="image/*"
										onChange={(e) => handleCourseImage(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course title:</div>
									<input
										type="text"
										className="form-control"
										placeholder="Enter Course Title name"
										onChange={(e) => setCourseTitle(e.target.value)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Overview:</div>
									<textarea
										className="form-control"
										placeholder="Enter Course Overview"
										rows="3"
										onChange={(e) => setAboutCourse(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleCourseOverviewFile(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Core Topics:</div>
									<textarea
										className="form-control"
										placeholder="Enter Core Topics"
										rows="3"
										onChange={(e) => setTopics(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleTopicsFile(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Target Audience:</div>
									<input
										type="text"
										className="form-control"
										placeholder="Enter Target Audience"
										onChange={(e) => setTargetAudience(e.target.value)}></input>
								</div>
							</div>

							<div>
								<div style={{ paddingTop: "20px", fontSize: "13px" }}>
									Curriculum Outline
								</div>

								<div style={{ paddingTop: "0px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Modules:</div>
									<textarea
										className="form-control"
										placeholder="Enter Modules"
										onChange={(e) => setModules(e.target.value)}></textarea>
								</div>
								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Course Duration in Hours:
									</div>
									<input
										className="form-control"
										placeholder="Enter Course Duration"
										type="text"
										onChange={(e) => setCourseDuration(e.target.value)}></input>
								</div>

								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Course validity in Days:
									</div>
									<input
										className="form-control"
										placeholder="Enter Course validity"
										type="text"
										onChange={(e) => setCourseValidity(e.target.value)}></input>
								</div>

								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Each Question duration in Mins:
									</div>
									<input
										className="form-control"
										placeholder="Enter each question duration"
										type="text"
										onChange={(e) =>
											setQuestionsDuration(e.target.value)
										}></input>
								</div>

								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Learning Outcomes:</div>
									<textarea
										className="form-control"
										placeholder="Enter Learning Outcomes"
										onChange={(e) =>
											setLearningOutcomes(e.target.value)
										}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleOutcomesFile(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										Steps in obtaining the certification:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter Steps in obtaining the certification"
										onChange={(e) => setObtaining(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleObtainingFile(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										Eligibility to take the course:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter Eligibility to take the course"
										onChange={(e) => setEligibility(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleEligibilityFile(e)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										How to proceed with this course:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter How to proceed with this course"
										onChange={(e) => setProceed(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleProceedFile(e)}></input>
								</div>
							</div>

							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Course Modules:</div>
							</div>

							<div className="row">
								<div className="col-4" style={{ paddingBottom: "10px" }}>
									<label style={{ fontSize: "13px" }}>Course Header</label>
								</div>
								<div className="col-4" style={{ paddingBottom: "10px" }}>
									<label style={{ fontSize: "13px" }}>Course File</label>
								</div>
								<div className="col-3" style={{ paddingBottom: "10px" }}>
									<label style={{ fontSize: "13px" }}>Course Section</label>
								</div>
							</div>
							<div
								style={{
									// height: "200px",
									overflowY: "auto",
									overflowX: "hidden",
								}}>
								{textlist.length > 1 && (
									<div
										style={{
											marginBottom: "10px",
											fontSize: "12px",
											color: "#666",
											fontStyle: "italic",
										}}>
										Drag and drop items to reorder them
									</div>
								)}
								{textlist.map((singletext, index) => (
									<div
										key={index}
										draggable
										onDragStart={(e) => handleDragStart(e, index)}
										onDragOver={handleDragOver}
										onDrop={(e) => handleDrop(e, index)}
										onDragEnd={handleDragEnd}
										style={{
											cursor: "grab",
											opacity: draggedItem === index ? 0.5 : 1,
											transform:
												draggedItem === index ? "scale(0.98)" : "scale(1)",
											transition: "all 0.2s ease",
											padding: "10px",
											margin: "5px 0",
											border:
												draggedItem === index
													? "2px dashed #20ce8f"
													: "1px solid transparent",
											borderRadius: "8px",
											backgroundColor:
												draggedItem === index
													? "rgba(32, 206, 143, 0.1)"
													: "transparent",
											userSelect: "none",
										}}>
										<div className="row">
											<div
												className="col-1"
												style={{
													paddingBottom: "10px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<div
													style={{
														cursor: "grab",
														fontSize: "16px",
														color: "#999",
														userSelect: "none",
														padding: "5px",
														borderRadius: "4px",
														transition: "all 0.2s ease",
													}}
													onMouseEnter={(e) => {
														e.target.style.color = "#20ce8f";
														e.target.style.backgroundColor =
															"rgba(32, 206, 143, 0.1)";
													}}
													onMouseLeave={(e) => {
														e.target.style.color = "#999";
														e.target.style.backgroundColor = "transparent";
													}}
													title="Drag to reorder">
													⋮⋮
												</div>
											</div>
											<div className="col-3" style={{ paddingBottom: "10px" }}>
												<input
													type="text"
													name="name"
													className="form-control"
													placeholder="Enter Course Header here"
													value={singletext.name}
													onChange={(e) =>
														handlertextrchange(e, index)
													}></input>
											</div>
											<div
												className="col-4"
												style={{ paddingBottom: "10px" }}
												onDrop={(e) => handleFileDrop(e, index)}
												onDragOver={handleFileDragOver}>
												<div style={{ position: "relative" }}>
													<input
														name="file"
														type="file"
														accept="application/pdf"
														className="form-control"
														style={{
															opacity: 0,
															position: "absolute",
															zIndex: 2,
															height: "38px",
															cursor: "pointer",
														}}
														onChange={(e) => handleFile(e, index)}></input>
													<div
														style={{
															position: "absolute",
															top: 0,
															left: 0,
															right: 0,
															height: "38px",
															backgroundColor: "#fff",
															border: "1px solid #ced4da",
															borderRadius: "0.375rem",
															padding: "6px 12px",
															display: "flex",
															alignItems: "center",
															zIndex: 1,
															pointerEvents: "none",
														}}>
														<span
															style={{ color: "#6c757d", fontSize: "14px" }}>
															{singletext.fileName ||
																(singletext.file !== "" &&
																singletext.file !== undefined &&
																!singletext.file.includes("blob")
																	? singletext.file.split("/")[2]
																	: "Choose PDF file")}
														</span>
													</div>
												</div>
											</div>
											<div className="col-3" style={{ paddingBottom: "10px" }}>
												<input
													type="text"
													name="section"
													className="form-control"
													placeholder="Enter Section"
													value={singletext.section}
													onChange={(e) =>
														handlertextrchange(e, index)
													}></input>
											</div>
											<div className="col-1">
												{textlist.length > 1 && (
													<img
														alt="icon"
														style={{ cursor: "pointer" }}
														onClick={() => handlertextremove(index)}
														src="../images/closeOne.png"></img>
												)}
											</div>
										</div>
									</div>
								))}
							</div>
							<div
								className="row"
								style={{ paddingTop: "20px", paddingBottom: "30px" }}>
								<div className="col">
									<div>
										<div>
											{textlist.length >= 1 && (
												<>
													<span
														onClick={handleTextadd}
														style={{ cursor: "pointer", marginRight: "20px" }}>
														<img
															alt="icon"
															style={{
																width: "18px",
																height: "18px",
																background: "#20ce8f",
																borderRadius: "20px",
															}}
															src="../images/Icon.png"></img>
														&nbsp;
														<span
															className="f-fm fm-w6-s16"
															style={{
																color: "#20ce8f",
																verticalAlign: "middle",
															}}>
															Add New File
														</span>
													</span>
													<AddExistingFiles
														courses={communities}
														showPdf={(file) => downloadPdf(file)}
														addFiles={(item) =>
															setTextlist([...textlist, ...item])
														}
													/>
												</>
											)}
											<br />
											<span
												// onClick={handleTextadd}
												style={{
													display:
														getButtonClass() === "aebuttonblack"
															? "none"
															: "block",
												}}
												// disabledClass={getButtonClass()}
											></span>
										</div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Course References:</div>
							</div>

							<div
								style={{
									// height: "200px",
									overflowY: "auto",
									overflowX: "hidden",
								}}>
								{referencelist.length > 1 && (
									<div
										style={{
											marginBottom: "10px",
											fontSize: "12px",
											color: "#666",
											fontStyle: "italic",
										}}>
										Drag and drop reference items to reorder them
									</div>
								)}
								{referencelist.map((singletext, index) => (
									<div key={`reference-${index}`}>
										<div
											draggable
											onDragStart={(e) => handleReferenceDragStart(e, index)}
											onDragOver={handleReferenceDragOver}
											onDrop={(e) => handleReferenceDrop(e, index)}
											onDragEnd={handleReferenceDragEnd}
											style={{
												cursor: "grab",
												opacity: draggedReferenceItem === index ? 0.5 : 1,
												transform:
													draggedReferenceItem === index
														? "scale(0.98)"
														: "scale(1)",
												transition: "all 0.2s ease",
												padding: "10px",
												margin: "5px 0",
												border:
													draggedReferenceItem === index
														? "2px dashed #20ce8f"
														: "1px solid transparent",
												borderRadius: "8px",
												backgroundColor:
													draggedReferenceItem === index
														? "rgba(32, 206, 143, 0.1)"
														: "transparent",
												userSelect: "none",
											}}>
											<div className="row">
												<div
													className="col-1"
													style={{
														paddingBottom: "10px",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}></div>
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>Title</label>
												</div>
												<div
													className="col-5"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>Name</label>
												</div>
											</div>
											<div className="row">
												<div
													className="col-1"
													style={{
														paddingBottom: "10px",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}>
													<div
														style={{
															cursor: "grab",
															fontSize: "16px",
															color: "#999",
															userSelect: "none",
															padding: "5px",
															borderRadius: "4px",
															transition: "all 0.2s ease",
														}}
														onMouseEnter={(e) => {
															e.target.style.color = "#20ce8f";
															e.target.style.backgroundColor =
																"rgba(32, 206, 143, 0.1)";
														}}
														onMouseLeave={(e) => {
															e.target.style.color = "#999";
															e.target.style.backgroundColor = "transparent";
														}}
														title="Drag to reorder">
														⋮⋮
													</div>
												</div>
												<div className="col-6" style={{ paddingLeft: "15px" }}>
													{/* <div style={{ fontSize: "13px" }}>Language:</div> */}
													<select
														name="title"
														value={
															typeof singletext.title === "object"
																? singletext.title?.id
																: singletext.title || ""
														}
														onChange={(e) => handlereferencechange(e, index)}>
														<option value="">Select</option>
														{references.map((e) => {
															return (
																<option value={e.id} key={e.id}>
																	{e.name}
																</option>
															);
														})}
													</select>
													<span style={{ marginLeft: "30px" }}>
														<Button
															onClick={() => {
																setShowReferenceModal(true);
																// setShowUploadModal(false);
															}}
															style={{ background: "#20ce8f", border: "none" }}>
															Add
														</Button>
													</span>
												</div>
												<div
													className="col-4"
													style={{ paddingBottom: "10px" }}>
													<input
														name="name"
														type="text"
														className="form-control"
														placeholder="Enter reference name"
														value={singletext.name}
														onChange={(e) =>
															handlereferencechange(e, index)
														}></input>
												</div>
												<div
													className="col-1"
													style={{ paddingBottom: "10px" }}>
													{referencelist.length > 1 && (
														<img
															alt="icon"
															style={{ cursor: "pointer" }}
															onClick={() => handlereferenceremove(index)}
															src="../images/closeOne.png"></img>
													)}
												</div>
											</div>
											<div className="row">
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>File</label>
												</div>
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>Link</label>
												</div>
											</div>
											<div className="row">
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}
													onDrop={(e) => handleReferenceFileDrop(e, index)}
													onDragOver={handleReferenceFileDragOver}>
													<div style={{ position: "relative" }}>
														<input
															name="file"
															type="file"
															className="form-control"
															accept="application/pdf"
															style={{
																opacity: 0,
																position: "absolute",
																zIndex: 2,
																height: "38px",
																cursor: "pointer",
															}}
															onChange={(e) =>
																handleReferenceFile(e, index)
															}></input>
														<div
															style={{
																position: "absolute",
																top: 0,
																left: 0,
																right: 0,
																height: "38px",
																backgroundColor: "#fff",
																border: "1px solid #ced4da",
																borderRadius: "0.375rem",
																padding: "6px 12px",
																display: "flex",
																alignItems: "center",
																zIndex: 1,
																pointerEvents: "none",
															}}>
															<span
																style={{ color: "#6c757d", fontSize: "14px" }}>
																{singletext.fileName ||
																	(singletext.file !== "" &&
																	singletext.file !== undefined &&
																	!singletext.file.includes("blob")
																		? singletext.file.split("/")[2]
																		: "Choose PDF file")}
															</span>
														</div>
													</div>
												</div>
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<input
														name="link"
														type="text"
														className="form-control"
														placeholder="Enter Links"
														value={singletext.link}
														onChange={(e) =>
															handlereferencechange(e, index)
														}></input>
												</div>
											</div>
											<div className="row">
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>Source</label>
												</div>
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<label style={{ fontSize: "13px" }}>
														Description
													</label>
												</div>
											</div>
											<div className="row">
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<input
														name="source"
														type="text"
														className="form-control"
														placeholder="Enter Source"
														value={singletext.source}
														onChange={(e) =>
															handlereferencechange(e, index)
														}></input>
												</div>
												<div
													className="col-6"
													style={{ paddingBottom: "10px" }}>
													<textarea
														className="form-control"
														name="description"
														placeholder="Enter Description"
														value={singletext.description}
														onChange={(e) =>
															handlereferencechange(e, index)
														}></textarea>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
							<div
								className="row"
								style={{ paddingTop: "20px", paddingBottom: "30px" }}>
								<div className="col">
									<div>
										<div>
											{referencelist.length >= 1 && (
												<>
													<span
														onClick={() => handleReferenceadd()}
														style={{ cursor: "pointer", marginRight: "20px" }}>
														<img
															alt="icon"
															style={{
																width: "18px",
																height: "18px",
																background: "#20ce8f",
																borderRadius: "20px",
															}}
															src="../images/Icon.png"></img>
														&nbsp;
														<span
															className="f-fm fm-w6-s16"
															style={{
																color: "#20ce8f",
																verticalAlign: "middle",
															}}>
															Add New Reference
														</span>
													</span>
												</>
											)}
											<br />
											<span
												style={{
													display:
														getButtonClass() === "aebuttonblack"
															? "none"
															: "block",
												}}></span>
										</div>
									</div>
								</div>
							</div>

							<div style={{ paddingTop: "15px" }}>
								<input
									type="checkbox"
									checked={retake}
									style={{ cursor: "pointer" }}
									onChange={(e) =>
										setRetake((retake) => setRetake(!retake))
									}></input>
								&nbsp;Retake Exam
							</div>
							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Cost of Course:</div>

								<input
									type="text"
									className="form-control"
									value={cost}
									placeholder="Enter course cost"
									onChange={(e) => setCost(e.target.value)}></input>
							</div>
							<div style={{ fontSize: "13px", fontWeight: 500 }}>
								(Note: In case of free course, leave the cost field empty!!!)
							</div>
						</div>

						<div className="col-5">
							<div style={{ paddingTop: "10px", fontSize: "13px" }}>
								Dynamic Questions and Answers:
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Question"
									value={question}
									onChange={(e) => setQuestion(e.target.value)}></input>
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<textarea
									className="form-control"
									placeholder="Enter options seperated by comma"
									value={answers}
									onChange={(e) => setAnswers(e.target.value)}></textarea>
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Answer"
									value={questionAnswer}
									onChange={(e) => setQuestionAnswer(e.target.value)}></input>
							</div>

							<div style={{ textAlign: "center" }}>
								<Button
									onClick={() => handleShowQuestion()}
									disabled={addbutton}
									style={{
										background: "#20ce8f",
										border: "none",
										width: "60px",
										borderRadius: "5px",
									}}>
									Add
								</Button>
							</div>

							{questionsList.length > 1 && (
								<div
									style={{
										marginBottom: "10px",
										fontSize: "12px",
										color: "#666",
										fontStyle: "italic",
									}}>
									Drag and drop questions to reorder them
								</div>
							)}
							{questionsList.map((questionData, index) => (
								<div
									key={index}
									draggable
									onDragStart={(e) => handleQuestionDragStart(e, index)}
									onDragOver={handleQuestionDragOver}
									onDrop={(e) => handleQuestionDrop(e, index)}
									onDragEnd={handleQuestionDragEnd}
									style={{
										borderRadius: "10px",
										margin: "10px",
										padding: "10px",
										cursor: "grab",
										opacity: draggedQuestionItem === index ? 0.5 : 1,
										transform:
											draggedQuestionItem === index
												? "scale(0.98)"
												: "scale(1)",
										transition: "all 0.2s ease",
										border:
											draggedQuestionItem === index
												? "2px dashed #20ce8f"
												: "1px solid #000",
										backgroundColor:
											draggedQuestionItem === index
												? "rgba(32, 206, 143, 0.1)"
												: "lightgray",
										userSelect: "none",
									}}>
									<div className="d-flex justify-content-between">
										<div className="d-flex align-items-center">
											<div
												style={{
													cursor: "grab",
													fontSize: "16px",
													color: "#999",
													userSelect: "none",
													padding: "5px",
													borderRadius: "4px",
													transition: "all 0.2s ease",
													marginRight: "10px",
												}}
												onMouseEnter={(e) => {
													e.target.style.color = "#20ce8f";
													e.target.style.backgroundColor =
														"rgba(32, 206, 143, 0.1)";
												}}
												onMouseLeave={(e) => {
													e.target.style.color = "#999";
													e.target.style.backgroundColor = "transparent";
												}}
												title="Drag to reorder">
												⋮⋮
											</div>
											<h3>{questionData.question}</h3>
										</div>

										<img
											alt="icon"
											style={{ cursor: "pointer", objectFit: "contain" }}
											onClick={() => handlerquestionremove(index)}
											src="../images/closeOne.png"></img>
									</div>
									{questionData.options.map((option, optionIndex) => (
										<div key={`question-${index}-option-${optionIndex}`}>
											<label>
												&nbsp;
												<input
													type="radio"
													value={option}
													checked={selectedOptions[index] === option}
													onChange={() => handleOptionChange(option)}
												/>
												&nbsp; {option}
											</label>
										</div>
									))}
								</div>
							))}
						</div>
					</div>

					<div
						style={{
							textAlign: "center",
							paddingBottom: "10px",
							paddingTop: "20px",
						}}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							onClick={() => {
								// setShowCard(true);
								// setShowUploadModal(false);
								trackPromise(handlePushItemsIntoArray());
							}}>
							Upload
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showLanguageModal}
				onHide={handleCloseLanguageModal}
				dialogClassName="modal-sm-30px"
				size="md"
				backdropClassName="childmodal"
				// backdrop="static"
				centered
				// onEntered={() => props.handleEntered}
			>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Add Language
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer" }}
							onClick={handleCloseLanguageModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div>
						<div
							style={{
								paddingTop: "15px",
								paddingLeft: "10px",
								paddingBottom: "10px",
							}}>
							<div style={{ fontSize: "13px" }}>Language:</div>
							<input
								type="text"
								className="form-control"
								placeholder="Enter Language"
								onChange={(e) => setLanguage(e.target.value)}></input>
						</div>
					</div>
					<div style={{ textAlign: "end", paddingBottom: "10px" }}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							disabled={language === ""}
							onClick={() => {
								// setShowCard(true);
								// setShowUploadModal(false);
								handleUploadlanguage();
							}}>
							Add
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showEditModal}
				onHide={handleCloseEditModal}
				dialogClassName="modal-sm-30px"
				size="xl"
				backdropClassName="childmodal"
				// backdrop="static"
				centered
				// onEntered={() => props.handleEntered}
			>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Edit Course
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer", textAlign: "right" }}
							onClick={handleCloseEditModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div className="row">
						<div className="col-7">
							<div>
								<div style={{ paddingTop: "10px", fontSize: "13px" }}>
									Welcome and Introduction
								</div>
								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Categorie:</div>
									<select
										value={selectedCategory}
										style={{ width: "85%" }}
										name="category"
										onChange={(e) => setSelectedCategory(e.target.value)}>
										<option value="">Select</option>
										{courseCategorieArray.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									<span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												setShowCategorieModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span>
								</div>
								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Sub Categorie:</div>
									<select
										name="subcategory"
										value={selectedSubCategory}
										onChange={(e) => setSelectedSubCategory(e.target.value)}>
										<option value="">Select</option>
										{courseSubCategorieArray.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									<span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												setShowSubCategorieModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span>
								</div>
								<div style={{ paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Language:</div>
									<select
										name="language"
										value={selectedLanguage}
										onChange={(e) => setSelectedLanguage(e.target.value)}>
										<option value="">Select</option>
										{languages.map((e) => {
											return (
												<option value={e.id} key={e.id}>
													{e.name}
												</option>
											);
										})}
									</select>
									<span style={{ marginLeft: "30px" }}>
										<Button
											onClick={() => {
												setShowLanguageModal(true);
												// setShowUploadModal(false);
											}}
											style={{ background: "#20ce8f", border: "none" }}>
											Add
										</Button>
									</span>
								</div>
								<div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Image:</div>
									<input
										type="file"
										className="form-control"
										accept="image/*"
										// value={courseImage}
										onChange={(e) => handleCourseImage(e)}></input>
									{courseImage !== "" ? (
										<img
											alt="course"
											style={{ marginTop: "5px" }}
											onError={(e) => {
												e.target.src = "../images/common-couse-image.png";
											}}
											width="150px"
											src={courseImage}
										/>
									) : (
										<img
											alt="course"
											style={{ marginTop: "5px" }}
											onError={(e) => {
												e.target.src = "../images/common-couse-image.png";
											}}
											width="150px"
											src="../images/common-couse-image.png"
										/>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course title:</div>
									<input
										type="text"
										className="form-control"
										value={courseTitle}
										placeholder="Enter Course Title name"
										onChange={(e) => setCourseTitle(e.target.value)}></input>
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Course Overview:</div>
									<textarea
										className="form-control"
										placeholder="Enter Course Overview"
										rows="3"
										value={aboutCourse}
										onChange={(e) => setAboutCourse(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										onChange={(e) => handleCourseOverviewFile(e)}></input>
									{courseOverviewFile === selectedCourse.overviewfile && (
										<>{courseOverviewFile.split("/")[2]}</>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Core Topics:</div>
									<textarea
										className="form-control"
										placeholder="Enter Core Topics"
										rows="3"
										value={topics}
										onChange={(e) => setTopics(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										// value={topicsActualFile}
										onChange={(e) => handleTopicsFile(e)}></input>

									{topicsFile === selectedCourse.topicsfile && (
										<>{topicsFile.split("/")[2]}</>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Target Audience:</div>
									<input
										type="text"
										className="form-control"
										placeholder="Enter Target Audience"
										value={targetAudience}
										onChange={(e) => setTargetAudience(e.target.value)}></input>
								</div>
							</div>

							<div>
								<div style={{ paddingTop: "20px", fontSize: "13px" }}>
									Curriculum Outline
								</div>

								<div style={{ paddingTop: "0px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Modules:</div>
									<textarea
										className="form-control"
										placeholder="Enter Modules"
										value={modules}
										onChange={(e) => setModules(e.target.value)}></textarea>
								</div>
								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Course Duration in Hours:
									</div>
									<input
										className="form-control"
										placeholder="Enter Course Duration"
										type="text"
										value={courseDuration}
										onChange={(e) => setCourseDuration(e.target.value)}></input>
								</div>

								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Course validity in Days:
									</div>
									<input
										className="form-control"
										placeholder="Enter Course validity"
										value={courseValidity}
										type="text"
										onChange={(e) => setCourseValidity(e.target.value)}></input>
								</div>

								<div
									style={{
										paddingTop: "15px",
										paddingBottom: "10px",
										paddingLeft: "10px",
									}}>
									<div style={{ fontSize: "13px" }}>
										Each Question duration in Mins:
									</div>
									<input
										className="form-control"
										value={questionsDuration}
										placeholder="Enter each question duration"
										type="text"
										onChange={(e) =>
											setQuestionsDuration(e.target.value)
										}></input>
								</div>

								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>Learning Outcomes:</div>
									<textarea
										className="form-control"
										placeholder="Enter Learning Outcomes"
										value={learningOutcomes}
										onChange={(e) =>
											setLearningOutcomes(e.target.value)
										}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										// value={outcomesActualFile}
										onChange={(e) => handleOutcomesFile(e)}></input>
									{outcomesFile === selectedCourse.outcomesfile && (
										<>{outcomesFile.split("/")[2]}</>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										Steps in obtaining the certification:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter Steps in obtaining the certification"
										value={obtaining}
										onChange={(e) => setObtaining(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										// value={obtainingActualFile}
										onChange={(e) => handleObtainingFile(e)}></input>
									{obtainingFile === selectedCourse.obtainingfile && (
										<>{obtainingFile.split("/")[2]}</>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										Eligibility to take the course:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter Eligibility to take the course"
										value={eligibility}
										onChange={(e) => setEligibility(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										// value={eligibilityActualFile}
										onChange={(e) => handleEligibilityFile(e)}></input>
									{eligibilityFile === selectedCourse.eligibilityfile && (
										<>{eligibilityFile.split("/")[2]}</>
									)}
								</div>
								<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
									<div style={{ fontSize: "13px" }}>
										How to proceed with this course:
									</div>
									<textarea
										className="form-control"
										placeholder="Enter How to proceed with this course"
										value={proceed}
										onChange={(e) => setProceed(e.target.value)}></textarea>
									<div style={{ textAlign: "center" }}>OR</div>
									<input
										type="file"
										accept="application/pdf"
										className="form-control"
										// value={proceedActualFile}
										onChange={(e) => handleProceedFile(e)}></input>
									{proceedFile === selectedCourse.howtoproceedfile && (
										<>{proceedFile.split("/")[2]}</>
									)}
								</div>
							</div>

							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Course Modules:</div>
							</div>

							<div className="row">
								<div className="col-5" style={{ paddingBottom: "10px" }}>
									<label style={{ fontSize: "13px" }}>Course Header</label>
								</div>
								<div className="col-5" style={{ paddingBottom: "10px" }}>
									<label style={{ fontSize: "13px" }}>Course File</label>
								</div>
							</div>
							<div
								style={{
									// height: "200px",
									overflowY: "auto",
									overflowX: "hidden",
								}}>
								{textlist.length > 1 && (
									<div
										style={{
											marginBottom: "10px",
											fontSize: "12px",
											color: "#666",
											fontStyle: "italic",
										}}>
										Drag and drop items to reorder them
									</div>
								)}
								{textlist.map((singletext, index) => (
									<div
										key={index}
										draggable
										onDragStart={(e) => handleDragStart(e, index)}
										onDragOver={handleDragOver}
										onDrop={(e) => handleDrop(e, index)}
										onDragEnd={handleDragEnd}
										style={{
											cursor: "grab",
											opacity: draggedItem === index ? 0.5 : 1,
											transform:
												draggedItem === index ? "scale(0.98)" : "scale(1)",
											transition: "all 0.2s ease",
											padding: "10px",
											margin: "5px 0",
											border:
												draggedItem === index
													? "2px dashed #20ce8f"
													: "1px solid transparent",
											borderRadius: "8px",
											backgroundColor:
												draggedItem === index
													? "rgba(32, 206, 143, 0.1)"
													: "transparent",
											userSelect: "none",
										}}>
										<div className="row">
											<div
												className="col-1"
												style={{
													paddingBottom: "10px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<div
													style={{
														cursor: "grab",
														fontSize: "16px",
														color: "#999",
														userSelect: "none",
														padding: "5px",
														borderRadius: "4px",
														transition: "all 0.2s ease",
													}}
													onMouseEnter={(e) => {
														e.target.style.color = "#20ce8f";
														e.target.style.backgroundColor =
															"rgba(32, 206, 143, 0.1)";
													}}
													onMouseLeave={(e) => {
														e.target.style.color = "#999";
														e.target.style.backgroundColor = "transparent";
													}}
													title="Drag to reorder">
													⋮⋮
												</div>
											</div>
											<div className="col-3" style={{ paddingBottom: "10px" }}>
												<input
													type="text"
													name="name"
													className="form-control"
													placeholder="Enter Course Header here"
													value={singletext.name}
													style={{
														border: "1px solid #ACACAC",
														borderRadius: "10px",
													}}
													onChange={(e) =>
														handlertextrchange(e, index)
													}></input>
											</div>
											<div
												className="col-4"
												style={{ paddingBottom: "10px" }}
												onDrop={(e) => handleFileDrop(e, index)}
												onDragOver={handleFileDragOver}>
												<div style={{ position: "relative" }}>
													<input
														name="file"
														type="file"
														accept="application/pdf"
														className="form-control"
														style={{
															opacity: 0,
															position: "absolute",
															zIndex: 2,
															height: "38px",
															cursor: "pointer",
														}}
														onChange={(e) => handleFile(e, index)}></input>
													<div
														style={{
															position: "absolute",
															top: 0,
															left: 0,
															right: 0,
															height: "38px",
															backgroundColor: "#fff",
															border: "1px solid #ced4da",
															borderRadius: "0.375rem",
															padding: "6px 12px",
															display: "flex",
															alignItems: "center",
															zIndex: 1,
															pointerEvents: "none",
														}}>
														<span
															style={{ color: "#6c757d", fontSize: "14px" }}>
															{singletext.fileName ||
																(singletext.file !== "" &&
																singletext.file !== undefined &&
																!singletext.file.includes("blob")
																	? singletext.file.split("/")[2]
																	: "Choose PDF file")}
														</span>
													</div>
												</div>
											</div>
											<div className="col-3" style={{ paddingBottom: "10px" }}>
												<input
													type="text"
													name="section"
													className="form-control"
													placeholder="Enter Section"
													// style={{
													//   border: "1px solid #ACACAC",
													//   borderRadius: "10px",
													// }}
													value={singletext.section}
													onChange={(e) =>
														handlertextrchange(e, index)
													}></input>
											</div>
											<div className="col-1">
												{textlist.length > 1 && (
													<img
														alt="icon"
														style={{ cursor: "pointer" }}
														onClick={() => handlertextremove(index)}
														src="../images/closeOne.png"></img>
												)}
											</div>
										</div>
									</div>
								))}
							</div>
							<div
								className="row"
								style={{ paddingTop: "20px", paddingBottom: "30px" }}>
								<div className="col">
									<div>
										<div>
											{textlist.length >= 1 && (
												<>
													<span
														onClick={handleTextadd}
														style={{ cursor: "pointer", marginRight: "20px" }}>
														<img
															alt="icon"
															style={{
																width: "18px",
																height: "18px",
																background: "#20ce8f",
																borderRadius: "20px",
															}}
															src="../images/Icon.png"></img>
														&nbsp;
														<span
															className="f-fm fm-w6-s16"
															style={{
																color: "#20ce8f",
																verticalAlign: "middle",
															}}>
															Add New File
														</span>
													</span>
													<AddExistingFiles
														courses={communities}
														showPdf={(file) => downloadPdf(file)}
														addFiles={(item) =>
															setTextlist([...textlist, ...item])
														}
													/>
												</>
											)}
											<br />
											<span
												// onClick={handleTextadd}
												style={{
													display:
														getButtonClass() === "aebuttonblack"
															? "none"
															: "block",
												}}
												// disabledClass={getButtonClass()}
											></span>
										</div>
									</div>
								</div>
							</div>
							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Course References:</div>
							</div>

							<div
								style={{
									// height: "200px",
									overflowY: "auto",
									overflowX: "hidden",
								}}>
								{referencelist.length > 1 && (
									<div
										style={{
											marginBottom: "10px",
											fontSize: "12px",
											color: "#666",
											fontStyle: "italic",
										}}>
										Drag and drop reference items to reorder them
									</div>
								)}
								{referencelist.map((singletext, index) => (
									<div
										key={`reference-${index}`}
										draggable
										onDragStart={(e) => handleReferenceDragStart(e, index)}
										onDragOver={handleReferenceDragOver}
										onDrop={(e) => handleReferenceDrop(e, index)}
										onDragEnd={handleReferenceDragEnd}
										style={{
											cursor: "grab",
											opacity: draggedReferenceItem === index ? 0.5 : 1,
											transform:
												draggedReferenceItem === index
													? "scale(0.98)"
													: "scale(1)",
											transition: "all 0.2s ease",
											padding: "10px",
											margin: "5px 0",
											border:
												draggedReferenceItem === index
													? "2px dashed #20ce8f"
													: "1px solid transparent",
											borderRadius: "8px",
											backgroundColor:
												draggedReferenceItem === index
													? "rgba(32, 206, 143, 0.1)"
													: "transparent",
											userSelect: "none",
										}}>
										<div className="row">
											<div
												className="col-1"
												style={{
													paddingBottom: "10px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}></div>
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>Title</label>
											</div>
											<div className="col-5" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>Name</label>
											</div>
										</div>
										<div className="row">
											<div
												className="col-1"
												style={{
													paddingBottom: "10px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<div
													style={{
														cursor: "grab",
														fontSize: "16px",
														color: "#999",
														userSelect: "none",
														padding: "5px",
														borderRadius: "4px",
														transition: "all 0.2s ease",
													}}
													onMouseEnter={(e) => {
														e.target.style.color = "#20ce8f";
														e.target.style.backgroundColor =
															"rgba(32, 206, 143, 0.1)";
													}}
													onMouseLeave={(e) => {
														e.target.style.color = "#999";
														e.target.style.backgroundColor = "transparent";
													}}
													title="Drag to reorder">
													⋮⋮
												</div>
											</div>
											<div className="col-6" style={{ paddingLeft: "15px" }}>
												{/* <div style={{ fontSize: "13px" }}>Language:</div> */}
												<select
													name="title"
													value={
														typeof singletext.title === "object"
															? singletext.title?.id
															: singletext.title || ""
													}
													onChange={(e) => handlereferencechange(e, index)}>
													<option value="">Select</option>
													{references.map((e) => {
														return (
															<option value={e.id} key={e.id}>
																{e.name}
															</option>
														);
													})}
												</select>

												<span style={{ marginLeft: "30px" }}>
													<Button
														onClick={() => {
															setShowReferenceModal(true);
															// setShowUploadModal(false);
														}}
														style={{ background: "#20ce8f", border: "none" }}>
														Add
													</Button>
												</span>
											</div>
											<div className="col-4" style={{ paddingBottom: "10px" }}>
												<input
													name="name"
													type="text"
													className="form-control"
													placeholder="Enter reference name"
													// style={{
													//   border: "1px solid #ACACAC",
													//   borderRadius: "10px",
													// }}
													value={singletext.name}
													onChange={(e) =>
														handlereferencechange(e, index)
													}></input>
											</div>
											<div className="col-1" style={{ paddingBottom: "10px" }}>
												{referencelist.length > 1 && (
													<img
														alt="icon"
														style={{ cursor: "pointer" }}
														onClick={() => handlereferenceremove(index)}
														src="../images/closeOne.png"></img>
												)}
											</div>
										</div>
										<div className="row">
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>File</label>
											</div>
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>Link</label>
											</div>
										</div>
										<div className="row">
											<div
												className="col-6"
												style={{ paddingBottom: "10px" }}
												onDrop={(e) => handleReferenceFileDrop(e, index)}
												onDragOver={handleReferenceFileDragOver}>
												<div style={{ position: "relative" }}>
													<input
														name="file"
														type="file"
														className="form-control"
														accept="application/pdf"
														style={{
															opacity: 0,
															position: "absolute",
															zIndex: 2,
															height: "38px",
															cursor: "pointer",
														}}
														onChange={(e) =>
															handleReferenceFile(e, index)
														}></input>
													<div
														style={{
															position: "absolute",
															top: 0,
															left: 0,
															right: 0,
															height: "38px",
															backgroundColor: "#fff",
															border: "1px solid #ced4da",
															borderRadius: "0.375rem",
															padding: "6px 12px",
															display: "flex",
															alignItems: "center",
															zIndex: 1,
															pointerEvents: "none",
														}}>
														<span
															style={{ color: "#6c757d", fontSize: "14px" }}>
															{singletext.fileName ||
																(singletext.file !== "" &&
																singletext.file !== undefined &&
																!singletext.file.includes("blob")
																	? singletext.file.split("/")[2]
																	: "Choose PDF file")}
														</span>
													</div>
												</div>
											</div>
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<input
													name="link"
													type="text"
													className="form-control"
													placeholder="Enter Links"
													value={singletext.link}
													onChange={(e) =>
														handlereferencechange(e, index)
													}></input>
											</div>
										</div>
										<div className="row">
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>Source</label>
											</div>
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<label style={{ fontSize: "13px" }}>Description</label>
											</div>
										</div>
										<div className="row">
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<input
													name="source"
													type="text"
													className="form-control"
													placeholder="Enter Source"
													value={singletext.source}
													onChange={(e) =>
														handlereferencechange(e, index)
													}></input>
											</div>
											<div className="col-6" style={{ paddingBottom: "10px" }}>
												<textarea
													className="form-control"
													name="description"
													placeholder="Enter Description"
													value={singletext.description}
													onChange={(e) =>
														handlereferencechange(e, index)
													}></textarea>
											</div>
										</div>
									</div>
								))}
							</div>
							<div
								className="row"
								style={{ paddingTop: "20px", paddingBottom: "30px" }}>
								<div className="col">
									<div>
										<div>
											{referencelist.length >= 1 && (
												<>
													<span
														onClick={() => handleReferenceadd()}
														style={{ cursor: "pointer", marginRight: "20px" }}>
														<img
															alt="icon"
															style={{
																width: "18px",
																height: "18px",
																background: "#20ce8f",
																borderRadius: "20px",
															}}
															src="../images/Icon.png"></img>
														&nbsp;
														<span
															className="f-fm fm-w6-s16"
															style={{
																color: "#20ce8f",
																verticalAlign: "middle",
															}}>
															Add New Reference
														</span>
													</span>
												</>
											)}
											<br />
											<span
												style={{
													display:
														getButtonClass() === "aebuttonblack"
															? "none"
															: "block",
												}}></span>
										</div>
									</div>
								</div>
							</div>

							<div style={{ paddingTop: "15px" }}>
								<input
									type="checkbox"
									style={{ cursor: "pointer" }}
									checked={retake}
									onChange={(e) => setRetake(e.target.checked)}></input>
								&nbsp;Retake Exam
							</div>
							<div style={{ paddingTop: "15px" }}>
								<div style={{ fontSize: "13px" }}>Cost of Course:</div>

								<input
									type="text"
									className="form-control"
									value={cost}
									placeholder="Enter course cost"
									onChange={(e) => setCost(e.target.value)}></input>
							</div>
							<div style={{ fontSize: "13px", fontWeight: 500 }}>
								(Note: In case of free course, leave the cost field empty!!!)
							</div>
						</div>
						<div className="col-5">
							<div style={{ paddingTop: "10px", fontSize: "13px" }}>
								Dynamic Questions and Answers:
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Question"
									value={question}
									onChange={(e) => setQuestion(e.target.value)}></input>
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<textarea
									className="form-control"
									placeholder="Enter options seperated by comma"
									value={answers}
									onChange={(e) => setAnswers(e.target.value)}></textarea>
							</div>
							<div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
								<input
									type="text"
									className="form-control"
									placeholder="Enter Answer"
									value={questionAnswer}
									onChange={(e) => setQuestionAnswer(e.target.value)}></input>
							</div>

							<div style={{ textAlign: "center" }}>
								<Button
									onClick={() => handleShowQuestion()}
									disabled={addbutton}
									style={{
										background: "#20ce8f",
										border: "none",
										width: "60px",
										borderRadius: "5px",
									}}>
									Add
								</Button>
							</div>

							{questionsList.length > 1 && (
								<div
									style={{
										marginBottom: "10px",
										fontSize: "12px",
										color: "#666",
										fontStyle: "italic",
									}}>
									Drag and drop questions to reorder them
								</div>
							)}
							{questionsList.map((questionData, index) => (
								<div
									key={index}
									draggable
									onDragStart={(e) => handleQuestionDragStart(e, index)}
									onDragOver={handleQuestionDragOver}
									onDrop={(e) => handleQuestionDrop(e, index)}
									onDragEnd={handleQuestionDragEnd}
									style={{
										borderRadius: "10px",
										margin: "10px",
										padding: "10px",
										cursor: "grab",
										opacity: draggedQuestionItem === index ? 0.5 : 1,
										transform:
											draggedQuestionItem === index
												? "scale(0.98)"
												: "scale(1)",
										transition: "all 0.2s ease",
										border:
											draggedQuestionItem === index
												? "2px dashed #20ce8f"
												: "1px solid #000",
										backgroundColor:
											draggedQuestionItem === index
												? "rgba(32, 206, 143, 0.1)"
												: "lightgray",
										userSelect: "none",
									}}>
									<div className="d-flex justify-content-between">
										<div className="d-flex align-items-center">
											<div
												style={{
													cursor: "grab",
													fontSize: "16px",
													color: "#999",
													userSelect: "none",
													padding: "5px",
													borderRadius: "4px",
													transition: "all 0.2s ease",
													marginRight: "10px",
												}}
												onMouseEnter={(e) => {
													e.target.style.color = "#20ce8f";
													e.target.style.backgroundColor =
														"rgba(32, 206, 143, 0.1)";
												}}
												onMouseLeave={(e) => {
													e.target.style.color = "#999";
													e.target.style.backgroundColor = "transparent";
												}}
												title="Drag to reorder">
												⋮⋮
											</div>
											<h3>{questionData.question}</h3>
										</div>

										<img
											alt="icon"
											style={{ cursor: "pointer", objectFit: "contain" }}
											onClick={() => handlerquestionremove(index)}
											src="../images/closeOne.png"></img>
									</div>
									{questionData.options.map((option, optionIndex) => (
										<div key={`edit-question-${index}-option-${optionIndex}`}>
											<label>
												&nbsp;
												<input
													type="radio"
													value={option}
													checked={selectedOptions[index] === option}
													onChange={() => handleOptionChange(option)}
												/>
												&nbsp; {option}
											</label>
										</div>
									))}
								</div>
							))}
						</div>
					</div>

					<div
						style={{
							textAlign: "center",
							paddingBottom: "10px",
							paddingTop: "20px",
						}}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							onClick={() => {
								handleEditSubmit();
							}}>
							Edit course
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showReferenceModal}
				onHide={handleCloseReferenceModal}
				dialogClassName="modal-sm-30px"
				size="md"
				backdropClassName="childmodal"
				centered>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Add Reference Title
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer" }}
							onClick={handleCloseReferenceModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div>
						<div
							style={{
								paddingTop: "15px",
								paddingLeft: "10px",
								paddingBottom: "10px",
							}}>
							<div style={{ fontSize: "13px" }}>Reference Title:</div>
							<input
								type="text"
								className="form-control"
								placeholder="Enter Reference Title"
								onChange={(e) => setReference(e.target.value)}></input>
						</div>
					</div>
					<div style={{ textAlign: "end", paddingBottom: "10px" }}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							disabled={reference === ""}
							onClick={() => {
								handleUploadReference();
							}}>
							Add
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showCategorieModal}
				onHide={handleCloseCategorieModal}
				dialogClassName="modal-sm-30px"
				size="md"
				backdropClassName="childmodal"
				centered>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Add Course Categorie
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer" }}
							onClick={handleCloseCategorieModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div>
						<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
							<div style={{ fontSize: "13px" }}>Course Categorie Name:</div>
							<input
								type="text"
								className="form-control"
								placeholder="Enter Course Categorie name"
								onChange={(e) => setCourseName(e.target.value)}></input>
						</div>
						<div
							style={{
								paddingTop: "15px",
								paddingLeft: "10px",
								paddingBottom: "10px",
							}}>
							<div style={{ fontSize: "13px" }}>
								Course Categorie Description:
							</div>
							<textarea
								type="text"
								className="form-control"
								placeholder="Enter Course Categorie Description"
								onChange={(e) =>
									setCourseDescription(e.target.value)
								}></textarea>
						</div>
					</div>
					<div style={{ textAlign: "end", paddingBottom: "10px" }}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							disabled={courseName === "" || courseDescription === ""}
							onClick={() => {
								trackPromise(handlePushItemIntoCourseCategorieArray());
							}}>
							Save
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={showSubCategorieModal}
				onHide={handleCloseSubCategorieModal}
				dialogClassName="modal-sm-30px"
				size="md"
				backdropClassName="childmodal"
				centered>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row" style={{ background: "#F4F7F9" }}>
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "15px",
								}}>
								Add Course Sub Categorie
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "15px", cursor: "pointer" }}
							onClick={handleCloseSubCategorieModal}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<div>
						<div style={{ paddingLeft: "10px" }}>
							<div style={{ fontSize: "13px" }}>Course Categorie:</div>
							<select
								name="category"
								style={{ width: "85%" }}
								defaultValue={selectedCategory}
								onChange={(e) => setSelectedCategory(e.target.value)}>
								<option value="">Select</option>
								{courseCategorieArray.map((e) => {
									return (
										<option value={e.id} key={e.id}>
											{e.name}
										</option>
									);
								})}
							</select>
						</div>
						<div style={{ paddingTop: "15px", paddingLeft: "10px" }}>
							<div style={{ fontSize: "13px" }}>Course Sub Categorie Name:</div>
							<input
								type="text"
								className="form-control"
								placeholder="Enter Course Sub Categorie name"
								onChange={(e) => setSubCourseName(e.target.value)}></input>
						</div>
						<div
							style={{
								paddingTop: "15px",
								paddingLeft: "10px",
								paddingBottom: "10px",
							}}>
							<div style={{ fontSize: "13px" }}>
								Course Sub Categorie Description:
							</div>
							<textarea
								type="text"
								className="form-control"
								placeholder="Enter Course Sub Categorie Description"
								onChange={(e) =>
									setSubCourseDescription(e.target.value)
								}></textarea>
						</div>
					</div>
					<div style={{ textAlign: "end", paddingBottom: "10px" }}>
						<Button
							style={{ background: "#20ce8f", border: "none" }}
							disabled={subCourseName === "" || subCourseDescription === ""}
							onClick={() => {
								handlePushItemIntoCourseSubCategorieArray();
							}}>
							Save
						</Button>
					</div>
				</Modal.Body>
			</Modal>

			<Navbar />

			<div style={{ backgroundColor: "#fff" }}>
				<div>
					<Homecarousel />
				</div>
				<div className="tab-m">
					<div id="Tab">
						<ul className="nav1 nav-tabs1">
							<li className={activeTab === "courses" ? "active pb-c" : "pb-c"}>
								<a
									href="#1"
									data-toggle="tab"
									onClick={() => setActiveTab("courses")}>
									Courses
								</a>
							</li>
							<li className={activeTab === "mycourses" ? "active" : ""}>
								<a
									href="#2"
									data-toggle="tab"
									onClick={() => setActiveTab("mycourses")}>
									My courses
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div className="tab-content ">
					<div
						className={activeTab === "courses" ? "tab-pane active" : "tab-pane"}
						id="1">
						<div className="container  pt-c" style={{ padding: "50px 0" }}>
							<div className="col-12">
								{userRole === "Admin" && (
									<>
										<Addfreecourse
											languages={languages}
											showLanguageModel={() => setShowLanguageModal(true)}
										/>

										<Button
											className="mb-c"
											style={{
												background: "#36BB7D",
												fontSize: "13px",
												borderRadius: "4px",
												border: "none",
												marginRight: "5px",
											}}
											onClick={() => setShowUploadModal(true)}>
											+ Add New Course
										</Button>

										<Button
											style={{
												background: "#b51d1d",
												fontSize: "13px",
												borderRadius: "4px",
												border: "none",
											}}
											onClick={() =>
												(window.location.href = "/usermanagement")
											}>
											Super Admin Dashboard
										</Button>
									</>
								)}
							</div>

							{/* Search and Language Filter */}
							<div
								className="row"
								style={{ marginTop: "20px", marginBottom: "20px" }}>
								<div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
									<div className="uc-searchBar">
										<input
											type="text"
											placeholder="Search courses..."
											onChange={(e) => setCourseSearchValue(e.target.value)}
											className="uc-formControl1"
											style={{ width: "100%" }}
										/>
									</div>
								</div>
								<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "flex-end",
										}}>
										<div style={{ fontSize: "13px", marginRight: "10px" }}>
											Language:
										</div>
										<select
											name="language"
											style={{ width: "150px" }}
											onChange={(e) =>
												setSelectedDisplayLanguage(e.target.value)
											}>
											<option value="">All Languages</option>
											{languages.map((lang) => (
												<option value={lang.id} key={lang.id}>
													{lang.name}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>

							{/* No Results Message */}
							{!auxLoading && !hasAnyCourses() && (
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										padding: "30px 30px",
									}}>
									<ul className="uc-res-li-1 view-as uc-my-book-list uc-grid">
										<div className="uc-NRF">
											<img src="../images/Search-no-results-found.svg" alt="" />
											<h5
												style={{
													fontSize: "28px",
													fontWeight: "300",
													color: "#62DDB2",
													textAlign: "center",
												}}>
												{selectedDisplayLanguage === ""
													? "No courses found matching your search"
													: "No courses available in the selected language"}
											</h5>
										</div>
									</ul>
								</div>
							)}

							{(auxLoading || organisationArray.length > 0) &&
								hasAnyFreeCourses() && (
									<Accordion
										style={{
											marginTop: "10px",
											marginBottom: "10px",
										}}>
										<Accordion.Item eventKey={"free"}>
											<Accordion.Header>
												<div style={{ fontWeight: "500", fontSize: "18px" }}>
													Free Courses
												</div>
											</Accordion.Header>

											<Accordion.Body className="row">
												{auxLoading ? (
													<div className="row">
														{[...Array(4)].map((_, i) => (
															<div className="col-12 pl-cr" key={i}>
																<Skeleton
																	height={55}
																	style={{ marginBottom: 16 }}
																/>
															</div>
														))}
													</div>
												) : (
													organisationArray.map((c, index) => {
														// Only show organization if it has free courses after filtering
														if (hasFreeCoursesInOrganization(c)) {
															return (
																<Accordion
																	style={{ marginBottom: "10px" }}
																	key={`org-${index}-${c}`}>
																	<Accordion.Item eventKey={c}>
																		<Accordion.Header>
																			<div
																				style={{
																					fontWeight: "500",
																					fontSize: "18px",
																				}}>
																				{c}
																			</div>
																		</Accordion.Header>
																		<Accordion.Body>
																			<div className="row">
																				{displayFreeCoursesArray.map(
																					(e, freeCourseIndex) => {
																						if (e.organisation.name === c) {
																							return (
																								<div
																									className="col-xl-3 col-md-6 col-lg-3 col-sm-12 pl-cr"
																									key={`free-course-${freeCourseIndex}-${e.id}`}>
																									<Card
																										className="fadeup d-flex flex-column"
																										style={{
																											width: "100%",
																											height: "100%",
																										}}>
																										<div>
																											<a href="">
																												<div>
																													<img
																														style={{
																															width: "100%",
																															height: "150px",
																														}}
																														decoding="async"
																														src="../images/common-couse-image.png"
																														alt={e.name}
																														loading="lazy"
																													/>
																												</div>
																											</a>
																										</div>
																										<Card.Body
																											className="d-flex flex-column"
																											style={{
																												width: "100%",
																												height: "100%",
																												justifyContent:
																													"space-between",
																											}}>
																											<div>
																												<a
																													className="text-course card-cost"
																													style={{
																														padding: "0",
																													}}>
																													{e.name}
																												</a>
																												<div className="card-duration">
																													<span className="card-duration">
																														{" "}
																														Language:
																														&nbsp;&nbsp;
																														<span>
																															{e.language?.name}
																														</span>
																													</span>
																												</div>
																												<div className="card-duration">
																													<span className="card-duration">
																														{" "}
																														Subject:
																														&nbsp;&nbsp;
																														<span>
																															{e.subject}
																														</span>
																													</span>
																												</div>
																												<div className="card-duration">
																													<span className="card-duration">
																														{" "}
																														Source link:
																														&nbsp;&nbsp;
																														<FreeCourseRegister
																															link={
																																e.sourcelink
																															}
																															courseid={e.id}
																															onSuccess={() => setRefreshTrigger(prev => prev + 1)}
																														/>
																													</span>
																												</div>
																											</div>
																										</Card.Body>
																									</Card>
																								</div>
																							);
																						}
																						return null;
																					},
																				)}
																			</div>
																		</Accordion.Body>
																	</Accordion.Item>
																</Accordion>
															);
														}
														return null;
													})
												)}
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								)}

							{/* Main Courses Section Skeleton Loader */}
							{mainLoading ? (
								<div className="row">
									{[...Array(4)].map((_, i) => (
										<div className="col-12 pl-cr" key={i}>
											<Skeleton height={55} style={{ marginBottom: 16 }} />
										</div>
									))}
								</div>
							) : (
								// CATEGORIES_ARRAY.map((c, categoryIndex) => {
								// 	return (
								// <div key={`category-${categoryIndex}-${c}`}>
								courseCategorieArray.map((cc, ccIndex) => {
									if (
										// c === cc.name &&
										JSON.stringify(communitiesArray).includes(cc.id) &&
										hasCoursesInCategory(cc.id)
									) {
										return (
											<div key={`cc-${ccIndex}-${cc.id}`}>
												<Accordion
													style={{
														marginTop: "10px",
														marginBottom: "10px",
													}}
													defaultActiveKey={activeKey}>
													<Accordion.Item eventKey={ccIndex} id={ccIndex}>
														<Accordion.Header>
															<div
																style={{
																	fontWeight: "500",
																	fontSize: "18px",
																}}>
																{cc.name}
															</div>
														</Accordion.Header>
														<Accordion.Body className="row">
															{cc.subcategories?.map((s, subIndex) => {
																if (
																	JSON.stringify(communitiesArray).includes(
																		s.id,
																	) &&
																	hasCoursesInSubcategory(s.id)
																) {
																	return (
																		<Accordion
																			key={`sub-${subIndex}-${s.id}`}
																			style={{
																				marginBottom: "10px",
																			}}>
																			<Accordion.Item eventKey={s.name}>
																				<Accordion.Header>
																					<div
																						style={{
																							fontWeight: "500",
																							fontSize: "18px",
																						}}>
																						{s.name}
																					</div>
																				</Accordion.Header>
																				<Accordion.Body>
																					<div className="row">
																						{displayCoursesArray.map(
																							(e, courseIndex) => {
																								if (e.subcategory.id === s.id) {
																									return (
																										<div
																											className="col-xl-3 col-lg-3 col-md-6 col-sm-12 pl-cr"
																											key={`course-${courseIndex}-${e.id}`}>
																											<Card
																												className="fadeup d-flex flex-column"
																												style={{
																													width: "100%",
																													height: "100%",
																												}}>
																												<div>
																													<a>
																														<div>
																															<img
																																onClick={() =>
																																	(window.location.href =
																																		"/courseinfo/" +
																																		e.id)
																																}
																																style={{
																																	pointer:
																																		"cursor",
																																	width: "100%",
																																	height:
																																		"150px",
																																}}
																																decoding="async"
																																onError={(
																																	e,
																																) => {
																																	e.target.src =
																																		"../images/common-couse-image.png";
																																}}
																																src={
																																	e.courseimage
																																}
																																alt={
																																	e.coursetitle
																																}
																																loading="lazy"
																															/>
																														</div>
																													</a>
																												</div>

																												<Card.Body
																													className="d-flex flex-column"
																													style={{
																														width: "100%",
																														height: "100%",
																														justifyContent:
																															"space-between",
																													}}>
																													<div>
																														<a
																															className="text-course card-cost"
																															href={
																																"/courseinfo/" +
																																e.id
																															}
																															style={{
																																cursor:
																																	"pointer",
																																padding: "0",
																															}}>
																															{e.coursetitle}
																														</a>

																														{e.duration !==
																															"" && (
																															<div className="card-duration">
																																<i
																																	className="fa fa-clock "
																																	style={{
																																		padding: "",
																																		color: "",
																																	}}></i>
																																<span className="card-duration">
																																	{" "}
																																	Duration:
																																	&nbsp;&nbsp;
																																	<span>
																																		{e.duration}
																																		&nbsp;
																																	</span>
																																	Hrs
																																</span>
																															</div>
																														)}
																														<div className="card-duration">
																															<span className="card-duration">
																																<div
																																	style={{
																																		fontSize:
																																			"12px",
																																	}}>
																																	Language:
																																	&nbsp;&nbsp;
																																	<span
																																		style={{
																																			textDecoration:
																																				"underline",
																																		}}>
																																		{
																																			e.language
																																				.name
																																		}
																																	</span>{" "}
																																</div>
																															</span>
																														</div>
																														<div className="card-duration">
																															<span className="card-duration">
																																{e.cost === ""
																																	? "Free"
																																	: "₹" +
																																		e.cost}
																															</span>
																														</div>
																													</div>

																													<div className="d-grid">
																														{userRole ===
																															"Admin" && (
																															<>
																																<div className="col-12 d-flex justify-content-around">
																																	<Button
																																		style={{
																																			fontSize:
																																				"13px",
																																			borderRadius:
																																				"4px",
																																			border:
																																				"none",
																																		}}
																																		className="btn btn-warning"
																																		onClick={() =>
																																			handleEditCourse(
																																				e,
																																			)
																																		}>
																																		<i className="fas fa-edit"></i>
																																		Edit course
																																	</Button>
																																	<Button
																																		style={{
																																			background:
																																				"#E23F1C",
																																			fontSize:
																																				"13px",
																																			borderRadius:
																																				"4px",
																																			border:
																																				"none",
																																		}}
																																		onClick={() =>
																																			handleDeleteClick(
																																				e,
																																			)
																																		}>
																																		<i
																																			className="fa fa-trash"
																																			aria-hidden="true"></i>{" "}
																																		Delete
																																		course
																																	</Button>
																																</div>
																															</>
																														)}
																													</div>
																												</Card.Body>
																											</Card>
																										</div>
																									);
																								}
																								return null;
																							},
																						)}
																					</div>
																				</Accordion.Body>
																			</Accordion.Item>
																		</Accordion>
																	);
																}
																return null;
															})}
															{cc.name ===
																"Students: Skill Development for Students in Agriculture, Horticulture, and Food Sciences" && (
																// <h3>
																// 	Note: <b></b>For other courses, go to the On-Farm
																// 	Production section
																// </h3>
																<div
																	style={{
																		background: "#eafaf4",
																		borderLeft: "5px solid #20ce8f",
																		padding: "16px 20px",
																		margin: "24px 0",
																		borderRadius: "8px",
																		boxShadow:
																			"0 2px 8px rgba(32,206,143,0.08)",
																		display: "flex",
																		alignItems: "center",
																		gap: "12px",
																	}}>
																	<i
																		className="fa fa-info-circle"
																		style={{
																			color: "#20ce8f",
																			fontSize: "22px",
																			marginRight: "8px",
																		}}
																		aria-hidden="true"></i>
																	<div
																		style={{
																			fontSize: "16px",
																			color: "#1a5c4a",
																		}}>
																		<strong>Note:</strong> For other courses, go
																		to the <b>On-Farm Production</b> section.
																	</div>
																</div>
															)}
														</Accordion.Body>
													</Accordion.Item>
												</Accordion>
											</div>
										);
									}
									return null;
								})
								// </div>
								// 	);
								// })
							)}
						</div>
					</div>
					<div
						className={
							activeTab === "mycourses" ? "tab-pane active" : "tab-pane"
						}
						id="2">
						<div className="container pt-c" style={{ padding: "50px 0" }}>
							<div className="col-12">
								{userRole === "Admin" && (
									<>
										<Addfreecourse
											languages={languages}
											showLanguageModel={() => setShowLanguageModal(true)}
										/>

										<Button
											className="mb-c"
											style={{
												background: "#36BB7D",
												fontSize: "13px",
												borderRadius: "4px",
												border: "none",
												marginRight: "5px",
											}}
											onClick={() => setShowUploadModal(true)}>
											+ Add New Course
										</Button>

										<Button
											style={{
												background: "#b51d1d",
												fontSize: "13px",
												borderRadius: "4px",
												border: "none",
											}}
											onClick={() =>
												(window.location.href = "/usermanagement")
											}>
											Super Admin Dashboard
										</Button>
									</>
								)}
							</div>

							<div className="row pt-3  justify-content-center">
								<ProfileBanner />
								<div
									className="col-12 card"
									style={{
										// marginRight: "75px",
										border: "none",
										borderRadiusTop: "15px",
										marginLeft: "10px",
										borderRadius: "15px",
									}}>
									<div>
										{/* Search and Language Filter for My Courses */}
										{auth.user !== undefined && (
											<div
												className="row"
												style={{ marginBottom: "20px", padding: "15px" }}>
												<div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
													<div className="uc-searchBar">
														<input
															type="text"
															placeholder="Search my courses..."
															onChange={(e) =>
																setMyCoursesSearchValue(e.target.value)
															}
															className="uc-formControl1"
															style={{ width: "100%" }}
														/>
													</div>
												</div>
												<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
													<div
														style={{
															display: "flex",
															alignItems: "center",
															justifyContent: "flex-end",
														}}>
														<div
															style={{ fontSize: "13px", marginRight: "10px" }}>
															Language:
														</div>
														<select
															name="language"
															style={{ width: "150px" }}
															onChange={(e) =>
																setSelectedMyCoursesLanguage(e.target.value)
															}>
															<option value="">All Languages</option>
															{languages.map((lang) => (
																<option value={lang.id} key={lang.id}>
																	{lang.name}
																</option>
															))}
														</select>
													</div>
												</div>
											</div>
										)}

										{/* No Results Message for My Courses */}
										{displayMyCoursesArray.length === 0 && (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													padding: "30px 30px",
												}}>
												<ul className="uc-res-li-1 view-as uc-my-book-list uc-grid">
													<div className="uc-NRF">
														<img
															src="../images/Search-no-results-found.svg"
															alt=""
														/>
														<h5
															style={{
																fontSize: "28px",
																fontWeight: "300",
																color: "#62DDB2",
																textAlign: "center",
															}}>
															{selectedMyCoursesLanguage === ""
																? "No courses found matching your search"
																: "No courses available in the selected language"}
														</h5>
													</div>
												</ul>
											</div>
										)}

										<div className="row">
											{
												// userRole !== "Admin"
												// ? savedCourses
												// :
												auth.user !== undefined &&
													displayMyCoursesWithStartTime
														// changed
														.filter((course) => {
															// Admins see NOTHING in My Courses
															if (userRole === "Admin") return false;
															// Non-admins see only saved courses
															return course.isCourseSaved === true;
														})
														//changed
														.map((e, index) => {
															return (
																<div key={`my-course-${index}-${e.id}`}>
																	{/* {(userRole === "Admin" ||
															(userRole !== "Admin" && */}
																	{e.isCourseSaved === true && (
																		<div
																			className="col-12"
																			style={{
																				padding: "10px 10px 10px 10px",
																			}}>
																			<div
																				className="card"
																				style={{
																					padding: "5px 5px 5px 5px",
																					// visibility: showCard ? "visible" : "hidden",
																				}}>
																				<div className="row">
																					<div
																						className="col-xl-3 col-lg-3 col-md-6 col-sm-12"
																						style={{ cursor: "pointer" }}
																						onClick={() =>
																							(window.location.href =
																								"../courseinfo/" + e.id)
																						}>
																						<img
																							alt=""
																							onError={(e) => {
																								e.target.src =
																									"../images/common-couse-image.png";
																							}}
																							src={e.courseimage}
																							style={{ width: "100%" }}></img>
																					</div>
																					<div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
																						{" "}
																						<div
																							style={{
																								fontSize: "15px",
																								fontWeight: "500",
																								minHeight: "36px",
																							}}>
																							{e.coursetitle}
																						</div>
																						{e.language.name !== "English" && (
																							<div style={{ fontSize: "12px" }}>
																								Language&nbsp;&nbsp;
																								<span
																									style={{
																										textDecoration: "underline",
																									}}>
																									{e.language.name}
																								</span>{" "}
																							</div>
																						)}
																						{e.duration !== "" && (
																							<div style={{ fontSize: "12px" }}>
																								Duration&nbsp;&nbsp;
																								<span>{e.duration} Hrs</span>
																							</div>
																						)}
																						<div
																							style={{
																								fontSize: "15px",
																								fontWeight: "500",
																								paddingTop: "13px",
																								paddingBottom: "13px",
																							}}>
																							{e.cost === ""
																								? "Free"
																								: "₹" + e.cost}
																						</div>
																						<div>
																							Remaining validity:{" "}
																							{(() => {
																								const startTimeStr =
																									e?.coursestarttime;
																								const validityStr = e?.validity;

																								if (
																									!startTimeStr ||
																									!validityStr
																								)
																									return "-";

																								const start = new Date(
																									startTimeStr,
																								);
																								const validityDays =
																									Number(validityStr); // convert string to number

																								if (
																									isNaN(start.getTime()) ||
																									isNaN(validityDays)
																								)
																									return "-";

																								const now = new Date();
																								const elapsedMs = now - start;
																								const validityMs =
																									validityDays *
																									24 *
																									60 *
																									60 *
																									1000;

																								let remainingMs =
																									validityMs - elapsedMs;
																								if (remainingMs < 0)
																									remainingMs = 0;

																								const remainingDays =
																									Math.floor(
																										remainingMs /
																											(1000 * 60 * 60 * 24),
																									);
																								const remainingHours =
																									Math.floor(
																										(remainingMs %
																											(1000 * 60 * 60 * 24)) /
																											(1000 * 60 * 60),
																									);

																								const remainingMin = Math.floor(
																									(remainingMs %
																										(1000 * 60 * 60)) /
																										(1000 * 60),
																								);

																								return `${remainingDays}d ${remainingHours}h ${remainingMin}m`;
																							})()}
																						</div>
																					</div>
																					<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
																						<br />
																						<br />
																						<br />
																						{/* {e.courses_details > 0 && (
                                            <div
                                              className="lightgreen"
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              In Progress
                                            </div>
                                          )}

                                          <div
                                            style={{
                                              paddingTop: "10px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <Button
                                              style={{
                                                background: "#F96342",
                                                border: "none",
                                                width: "150px",
                                              }}
                                              onClick={() => {
                                                handleClick(
                                                  e.files,
                                                  e.courseimage,
                                                  e.coursetitle,
                                                  e.questionlist,
                                                  e.id,
                                                  e.admin,
                                                  e.courses_details
                                                );
                                              }}
                                            >
                                              {e.courses_details > 0
                                                ? "Resume"
                                                : "Start"}
                                            </Button>
                                          </div> */}

																						{(startedCourses[e.id] ||
																							e.courses_details > 0) && (
																							<div
																								className="lightgreen"
																								style={{ textAlign: "center" }}>
																								In Progress
																							</div>
																						)}

																						<div
																							style={{
																								paddingTop: "10px",
																								textAlign: "center",
																							}}>
																							<Button
																								style={{
																									background: "#F96342",
																									border: "none",
																									width: "150px",
																								}}
																								onClick={() => {
																									handleClick(
																										e.files,
																										e.courseimage,
																										e.coursetitle,
																										e.questionlist,
																										e.id,
																										e.admin,
																										e.courses_details,
																									);
																								}}>
																								{startedCourses[e.id] ||
																								e.courses_details > 0
																									? "Resume"
																									: "Start"}
																							</Button>
																						</div>

																						{/* Admin Edit and Delete Buttons */}
																						{userRole === "Admin" && (
																							<div
																								style={{
																									paddingTop: "10px",
																									textAlign: "center",
																								}}>
																								<div className="row">
																									<div className="col-12">
																										<Button
																											style={{
																												background: "#36BB7D",
																												border: "none",
																												// fontSize: "11px",

																												width: "150px",
																											}}
																											onClick={() =>
																												handleEditCourse(e)
																											}>
																											Edit
																										</Button>
																									</div>
																									<div
																										className="col-12"
																										style={{
																											paddingTop: "10px",
																										}}>
																										<Button
																											style={{
																												background: "#b51d1d",
																												border: "none",
																												// fontSize: "11px",
																												width: "150px",
																											}}
																											onClick={() =>
																												handleSetCourseInactive(
																													e,
																												)
																											}>
																											Delete
																										</Button>
																									</div>
																								</div>
																							</div>
																						)}
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
																</div>
															);
														})
											}
											{
												// savedCourses.length === 0
												auth.user === undefined && (
													<div
														style={{
															display: "flex",
															alignItems: "center",
															justifyContent: "center",
															padding: "30px 30px",
														}}>
														<ul className="uc-res-li-1 view-as uc-my-book-list uc-grid">
															<div className="uc-NRF">
																{/* <img
																	src="../images/Search-no-results-found.svg"
																	alt=""
																/> */}
																<h5
																	style={{
																		fontSize: "28px",
																		fontWeight: "700",
																		color: "#62DDB2",
																		textAlign: "center",
																	}}>
																	✅ <strong>My Courses:</strong> Once you
																	register for a course, you can view your
																	enrolled courses under the My Courses tab.
																</h5>
															</div>
														</ul>
													</div>
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
			<Modal
				show={showDeleteModal}
				onHide={handleCloseDeleteModal}
				centered
				size="sm">
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "18px" }}>Confirm Delete</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p style={{ margin: 0 }}>
						Are you sure you want to <strong>delete</strong> the course:
					</p>
					<p style={{ fontWeight: "500", margin: "10px 0", color: "#d32f2f" }}>
						"{courseToDelete?.coursetitle}"
					</p>
					<p style={{ fontSize: "14px", color: "#666" }}>
						This action <strong>cannot be undone</strong>.
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseDeleteModal}>
						Cancel
					</Button>
					<Button
						style={{ background: "#d32f2f", border: "none" }}
						onClick={handleConfirmDelete}>
						Yes, Delete
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
export default Courses;
